/* eslint-disable */
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { usePaged, Pagination } from '../utils';
function toWA(p){const r=(p||'').replace(/\D/g,'');return r.startsWith('593')?r:r.startsWith('0')&&r.length===10?'593'+r.substring(1):r.length===9?'593'+r:r;}
import {
  Users, Phone, MessageCircle, Calendar, Trophy, XCircle,
  TrendingUp, Activity, Star, Bell, AlertCircle, Zap,
  FileText, DollarSign, Plus, Trash2, CheckCircle, X,
  Send, Download, Edit2, ChevronLeft, ChevronRight,
  Save, RefreshCw, MessageSquare, Eye, Shield, Grid, Search, Clock,
  Flame, Thermometer, Snowflake, Target, Bot, FileSpreadsheet,
  ChevronDown, MapPin, CreditCard, Image, Gift} from 'lucide-react';
import { TabDashboard as InicioAdmin, PipelineTablero, syncAdminTheme } from './DashboardAdmin';
// DS is now a function that takes '#4f6ef7' color from props
const makeDS = (p = '#4f6ef7') => ({
  bg:'#f5f7fb', bg2:'#f8fafc', bg3:'#f1f5f9',
  surface:'#ffffff', surf2:'#f8fafc', surf3:'#f1f5f9',
  border:'1px solid #eaecf0', border2:'1.5px solid #e2e8f0',
  shadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',
  shadow2:'0 4px 20px rgba(0,0,0,0.09)',
  glass:'rgba(0,0,0,0.02)', glass2:'#ffffff',
  text1:'var(--dark,#0f172a)', text2:'#475569', text3:'#94a3b8',
  red:'#ef4444', green:'#10b981', yellow:'#f59e0b',
  blue: p, primary: p,
  purple:'#8b5cf6',
  fontHead:"'DM Sans',sans-serif", fontBody:"'DM Sans',sans-serif",
});
let DS = makeDS();
let CB = '#ffffff'; // card background (updated per company)
let CBorder = '#4f6ef720'; // card border
let CShadow = '0 2px 12px #4f6ef714'; // card shadow
let MOB = false; // true cuando la pantalla es móvil (< 768px)
// Estilo de Inicio/Pipeline (admin) compartido; NAVY = "Color de textos" de superadmin
const NAVY = 'var(--dark,#0f172a)';
function PageHead({ title, sub, right }) {
  return (
    <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', gap:12, flexWrap:'wrap', marginBottom:20, color:NAVY, fontFamily:"'DM Sans',sans-serif" }}>
      <div>
        <h1 style={{ margin:0, fontSize:MOB?22:28, fontWeight:800, letterSpacing:'-0.5px' }}>{title}</h1>
        {sub && <p style={{ margin:'4px 0 0', fontSize:14, color:'#64748b' }}>{sub}</p>}
      </div>
      {right}
    </div>
  );
}
const API = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '')
  : `${window.location.protocol}//${window.location.hostname}:3001`;
const tok = () => localStorage.getItem('crm_token');
async function apiFetch(method, endpoint, body) {
  const res = await fetch(`${API}${endpoint}`, {
    method,
    headers: { 'Content-Type':'application/json', Authorization:`Bearer ${tok()}` },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Error');
  return data;
}

/* ══ helpers ══ */
const fmtT = s => `${String(Math.floor(s/60)).padStart(2,'0')}:${String(s%60).padStart(2,'0')}`;
const ago = d => { const s=(Date.now()-new Date(d))/1000; if(s<60)return 'ahora'; if(s<3600)return `${Math.floor(s/60)}m`; if(s<86400)return `${Math.floor(s/3600)}h`; return `${Math.floor(s/86400)}d`; };
const dateStr = n => { const d=new Date(); d.setDate(d.getDate()+n); return d.toISOString().split('T')[0]; };

/* ══ Clasificación caliente/tibio/frío ══ */
const HEAT = {
  caliente:{ l:'¡A cerrar!',  c:'#10b981', b:'#f0fdf9', Icon:CheckCircle, dot:'#10b981', tip:'Este lead está listo — ¡prioridad máxima!' },
  tibio:   { l:'Seguir',      c:'#f59e0b', b:'#fefce8', Icon:Clock,       dot:'#f59e0b', tip:'Sigue en contacto — tiene potencial' },
  frio:    { l:'¡Rescátalo!', c:'#ef4444', b:'#fff1f2', Icon:Zap,         dot:'#ef4444', tip:'No lo abandones — una llamada puede cambiarlo todo' },
};
/* Nombres del estado que elige el asesor al editar (sin barra de score) */
const ESTADO_NOMBRE = { caliente:'Cierre', tibio:'Seguimiento', frio:'Frío' };
const LEAD_COLS = {
  caliente:{ label:'¡A cerrar!',  sub:'Listos para convertir — actúa YA',  color:'#10b981', bg:'#f0fdf9', border:'#a7f3d0' },
  tibio:   { label:'En seguimiento', sub:'Sigue llamando — tienen potencial', color:'#f59e0b', bg:'#fefce8', border:'#fde68a' },
  frio:    { label:'¡Rescátalos!', sub:'No los pierdas — una llamada puede cambiarlo', color:'#ef4444', bg:'#fff1f2', border:'#fecaca' },
};
const EVT_CFG = {
  llamada:  { Icon:Phone,          label:'Llamada',          color:'#10b981' },
  cita:     { Icon:Calendar,       label:'Cita',             color:'#4f6ef7' },
  cobro:    { Icon:DollarSign,     label:'Cliente por cobrar',color:'#f59e0b' },
  video:    { Icon:MessageCircle,  label:'Videollamada',     color:'#8b5cf6' },
};
const PAY_ST = { pending:{c:'#f59e0b',b:'#fef3c7',l:'Pendiente'}, overdue:{c:'#ef4444',b:'#fee2e2',l:'Vencido'}, paid:{c:'#10b981',b:'#d1fae5',l:'Pagado'} };

/* ══ Datos iniciales ══ */
if(!window.__CRM_MSGS__) window.__CRM_MSGS__=[
  { id:'m1', de:'sup', deNombre:'Rosa (Supervisora)', para:'asesor', texto:'¡Buen trabajo esta semana!', hora:new Date(Date.now()-3600000).toISOString(), leido:false },
  { id:'m2', de:'asesor', deNombre:'Yo', para:'sup', texto:'Gracias! Cerré a Diego hoy', hora:new Date(Date.now()-1800000).toISOString(), leido:true },
];

/* ══ ATOMS ══ */
function Bdg({l,c,b}){ return <span style={{padding:'2px 9px',borderRadius:999,fontSize:11,fontWeight:700,color:c,background:b,whiteSpace:'nowrap'}}>{l}</span>; }
function Panel({title,Icon,color=DS.primary,children,action}){
  return(
    <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',overflow:'hidden'}}>
      <div style={{padding:'16px 20px',borderBottom:'1px solid #eef0f3',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div style={{fontSize:16,fontWeight:700,color:NAVY,display:'flex',alignItems:'center',gap:8}}><Icon size={15} color={color}/>{title}</div>
        {action}
      </div>
      <div style={{padding:16}}>{children}</div>
    </div>
  );
}

function IBtn({onClick,bg,color,title,children}){ 
  return (
    <button 
      title={title} 
      onClick={onClick} 
      style={{
        padding: '5px 8px', 
        borderRadius: '7px', 
        border: 'none', 
        background: bg || '#eef2ff', 
        color: color || DS.primary, 
        cursor: 'pointer', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '4px', 
        fontWeight: 700, 
        fontSize: '11px'
      }}
    >
      {children}
    </button>
  ); 
}

function Modal({title,subtitle,width=440,onClose,children}){
  return(
    <div style={{position:'fixed',inset:0,backdropFilter:'blur(12px)',WebkitBackdropFilter:'blur(8px)',background:'rgba(var(--primary-rgb),0.35)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#ffffff',borderRadius:'20px',padding:'26px',width,maxHeight:'90vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:'18px'}}>
          <div><h2 style={{margin:'0 0 3px',fontSize:'17px',fontWeight:800,color:'var(--dark,#0f172a)'}}>{title}</h2>{subtitle&&<div style={{fontSize:'11px',color:'#9aa5be'}}>{subtitle}</div>}</div>
          <button onClick={onClose} style={{border:'none',background:'rgba(var(--primary-rgb),0.10)',borderRadius:'8px',padding:'7px',cursor:'pointer',display:'flex'}}><X size={13} color="#64748b"/></button>
        </div>
        {children}
      </div>
    </div>
  );
}

function Field({label,children}){ return <div><label style={{fontSize:'10px',color:'#9aa5be',fontWeight:700,display:'block',marginBottom:'5px'}}>{label}</label>{children}</div>; }
const inp = {padding:'10px 14px',border:'1.5px solid #e2e8f0',borderRadius:'10px',fontSize:'13px',outline:'none',width:'100%',boxSizing:'border-box',background:'#fff',color:'var(--dark,#0f172a)',fontFamily:"'DM Sans',sans-serif",transition:'border-color .2s,box-shadow .2s'};
const btn_primary = {padding:'11px 0',borderRadius:'12px',border:'none',background:'var(--primary)',color:'#fff',fontWeight:700,fontSize:'13px',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:'6px',fontFamily:"'DM Sans',sans-serif"};
const btn_cancel  = {padding:'11px',borderRadius:'10px',border:'1px solid #cbd5e1',background:'#f5f7fb',color:'#9aa5be',fontWeight:700,fontSize:'13px',cursor:'pointer'};

/* ══ CONFIRM MODAL ══ */
let _setConfirm = null;
function askConfirm(msg, onYes) { if (_setConfirm) _setConfirm({ msg, onYes }); }
function ConfirmModal({ msg, onYes, onClose }) {
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.55)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:20,padding:'28px 32px',width:340,boxShadow:'0 24px 64px rgba(0,0,0,0.18)',border:'1px solid #e2e8f0'}} onClick={e=>e.stopPropagation()}>
        <div style={{fontSize:18,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:8}}>¿Estás seguro?</div>
        <div style={{fontSize:13,color:'#64748b',marginBottom:24,lineHeight:1.6}}>{msg}</div>
        <div style={{display:'flex',gap:10}}>
          <button onClick={onClose} style={{flex:1,padding:'11px',borderRadius:10,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,fontSize:13,cursor:'pointer'}}>No, cancelar</button>
          <button onClick={()=>{onYes();onClose();}} style={{flex:1,padding:'11px',borderRadius:10,border:'none',background:'#ef4444',color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer'}}>Sí, eliminar</button>
        </div>
      </div>
    </div>
  );
}

/* ══ WHATSAPP APP CHOOSER ══ */
let _setWA = null;
function openWA(num, text, app) {
  const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
  const isAndroid = /Android/i.test(ua);
  if (isAndroid && app) {
    // En Android se puede abrir directamente la app elegida (WhatsApp o WhatsApp Business)
    const pkg = app === 'business' ? 'com.whatsapp.w4b' : 'com.whatsapp';
    const t = text ? `&text=${encodeURIComponent(text)}` : '';
    window.location.href = `intent://send?phone=${num}${t}#Intent;scheme=whatsapp;package=${pkg};end`;
  } else {
    // iOS / escritorio: el sistema decide qué app usar
    const t = text ? `?text=${encodeURIComponent(text)}` : '';
    window.open(`https://wa.me/${num}${t}`, '_blank');
  }
}
let _onContacto = null;
function askWhatsApp(phone, text = '', leadId = null) {
  const num = toWA(phone);
  if (!num) { alert('Este contacto no tiene un número de WhatsApp válido.'); return; }
  // Abrir WhatsApp = cliente contactado: se marca por teléfono (antes solo se registraba
  // si el botón tenía leadId, así que desde Mis Clientes seguía saliendo "sin contacto").
  apiFetch('POST', '/api/supervisor/contactado', { phone: num })
    .then(() => { if (_onContacto) _onContacto(); })
    .catch(()=>{});
  // Si el asesor ya eligió su app de WhatsApp, abrir directo sin volver a preguntar
  let pref = null;
  try { pref = localStorage.getItem('crm_wa_app'); } catch(e) {}
  if (pref === 'normal' || pref === 'business') { openWA(num, text, pref); return; }
  if (_setWA) _setWA({ num, text });
  else openWA(num, text);
}
function WhatsAppModal({ data, onClose }) {
  const { num, text } = data;
  const [remember, setRemember] = useState(true);
  const choose = (app) => {
    if (remember) { try { localStorage.setItem('crm_wa_app', app); } catch(e) {} }
    openWA(num, text, app);
    onClose();
  };
  return (
    <div style={{position:'fixed',inset:0,background:'rgba(15,23,42,0.55)',backdropFilter:'blur(4px)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:10000}} onClick={onClose}>
      <div style={{background:'#fff',borderRadius:20,padding:'26px 28px',width:340,boxShadow:'0 24px 64px rgba(0,0,0,0.18)',border:'1px solid #e2e8f0'}} onClick={e=>e.stopPropagation()}>
        <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
          <MessageCircle size={18} color="#25d366"/>
          <div style={{fontSize:17,fontWeight:800,color:'var(--dark,#0f172a)'}}>Abrir chat de WhatsApp</div>
        </div>
        <div style={{fontSize:13,color:'#64748b',marginBottom:20,lineHeight:1.5}}>¿Con qué aplicación quieres abrir el chat con <b>+{num}</b>?</div>
        <div style={{display:'flex',flexDirection:'column',gap:10}}>
          <button onClick={()=>choose('normal')} style={{padding:'13px',borderRadius:12,border:'none',background:'#25d366',color:'#fff',fontWeight:800,fontSize:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
            <MessageCircle size={16}/> WhatsApp
          </button>
          <button onClick={()=>choose('business')} style={{padding:'13px',borderRadius:12,border:'none',background:'#0a7d4b',color:'#fff',fontWeight:800,fontSize:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:8}}>
            <MessageCircle size={16}/> WhatsApp Business
          </button>
          <label style={{display:'flex',alignItems:'center',gap:8,fontSize:12.5,color:'#64748b',cursor:'pointer',padding:'4px 2px'}}>
            <input type="checkbox" checked={remember} onChange={e=>setRemember(e.target.checked)} style={{width:16,height:16,accentColor:'#25d366',cursor:'pointer'}}/>
            Recordar mi elección y no volver a preguntar
          </label>
          <button onClick={onClose} style={{padding:'11px',borderRadius:12,border:'1px solid #e2e8f0',background:'#f8fafc',color:'#64748b',fontWeight:700,fontSize:13,cursor:'pointer'}}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}

/* ══ CALL MODAL ══ */
function CallModal({client,onSave,onClose}){
  const [phase,setPhase]=useState('choose');
  const [secs,setSecs]=useState(0);
  const [notes,setNotes]=useState('');
  const [result,setResult]=useState('');
  const [via,setVia]=useState('llamada');
  const timerRef=useRef(null);

  function startCall(type){
    setVia(type);
    setPhase('calling');
    const raw=(client?.phone||'').replace(/\D/g,'');
    if(type==='llamada'){
      window.location.href=`tel:${client?.phone||''}`;
    } else {
      const wa=raw.startsWith('593')?raw:raw.startsWith('0')&&raw.length===10?'593'+raw.substring(1):raw.length===9?'593'+raw:raw;
      apiFetch('POST','/api/supervisor/contactado',{ phone:wa }).then(()=>{ if(_onContacto) _onContacto(); }).catch(()=>{});
      window.open(`https://wa.me/${wa}`,'_blank');
    }
    timerRef.current=setInterval(()=>setSecs(s=>s+1),1000);
  }
  function hangUp(){ clearInterval(timerRef.current); setPhase('saving'); }
  useEffect(()=>()=>clearInterval(timerRef.current),[]);

  const p=DS.primary;
  return(
    <Modal title="Llamar a cliente" subtitle={`${client?.name} · ${client?.phone}`} width={370} onClose={onClose}>
      {phase==='choose'&&(
        <div>
          <div style={{textAlign:'center',marginBottom:20,fontSize:13,color:'#64748b'}}>
            Elige cómo contactar a <b>{client?.name}</b>
          </div>
          <div style={{display:'flex',flexDirection:'column',gap:12}}>
            <button onClick={()=>startCall('llamada')}
              style={{padding:'16px 20px',borderRadius:14,border:`2px solid ${p}30`,background:`${p}08`,cursor:'pointer',display:'flex',alignItems:'center',gap:14,transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.background=`${p}14`;e.currentTarget.style.borderColor=p;}}
              onMouseLeave={e=>{e.currentTarget.style.background=`${p}08`;e.currentTarget.style.borderColor=`${p}30`;}}>
              <div style={{width:44,height:44,borderRadius:12,background:p,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <span style={{fontSize:20}}>📞</span>
              </div>
              <div style={{textAlign:'left'}}>
                <div style={{fontSize:14,fontWeight:800,color:'var(--dark,#0f172a)'}}>Llamada por teléfono</div>
                <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{client?.phone}</div>
              </div>
            </button>
            <button onClick={()=>startCall('whatsapp')}
              style={{padding:'16px 20px',borderRadius:14,border:'2px solid #25d36630',background:'#25d36608',cursor:'pointer',display:'flex',alignItems:'center',gap:14,transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.background='#25d36614';e.currentTarget.style.borderColor='#25d366';}}
              onMouseLeave={e=>{e.currentTarget.style.background='#25d36608';e.currentTarget.style.borderColor='#25d36630';}}>
              <div style={{width:44,height:44,borderRadius:12,background:'#25d366',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                <span style={{fontSize:20}}>💬</span>
              </div>
              <div style={{textAlign:'left'}}>
                <div style={{fontSize:14,fontWeight:800,color:'var(--dark,#0f172a)'}}>Llamada por WhatsApp</div>
                <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{client?.phone}</div>
              </div>
            </button>
          </div>
        </div>
      )}
      {phase==='calling'&&(
        <div style={{textAlign:'center',padding:'8px 0'}}>
          <div style={{fontSize:11,fontWeight:800,letterSpacing:1.5,color:via==='llamada'?p:'#25d366',marginBottom:10,textTransform:'uppercase'}}>
            {via==='llamada'?'📞 Llamada en curso':'💬 WhatsApp en curso'}
          </div>
          <div style={{fontSize:52,fontWeight:800,color:'var(--dark,#0f172a)',letterSpacing:3,marginBottom:24,fontVariantNumeric:'tabular-nums'}}>{fmtT(secs)}</div>
          <button onClick={hangUp}
            style={{padding:'14px 40px',borderRadius:999,border:'none',background:'#ef4444',color:'#fff',fontWeight:800,fontSize:15,cursor:'pointer',boxShadow:'0 4px 20px #ef444440'}}>
            📵 Colgar
          </button>
        </div>
      )}
      {phase==='saving'&&(
        <div>
          <div style={{textAlign:'center',background:'#f8fafc',borderRadius:12,padding:'12px',marginBottom:16,fontSize:13}}>
            <span style={{color:'#94a3b8'}}>Duración: </span>
            <span style={{fontWeight:800,color:'var(--dark,#0f172a)'}}>{fmtT(secs)}</span>
          </div>
          <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Notas de la llamada..." rows={3}
            style={{...inp,resize:'none',marginBottom:12}}/>
          <textarea value={result} onChange={e=>setResult(e.target.value)} placeholder="Resultado de la llamada..." rows={2}
            style={{...inp,resize:'none',marginBottom:16}}/>
          <button onClick={()=>onSave({dur:secs,notas:notes,resultado:result,type:via})}
            style={{...btn_primary,width:'100%',background:'#10b981',backgroundImage:'none'}}>
            ✓ Guardar y cerrar
          </button>
        </div>
      )}
    </Modal>
  );
}

/* ══ LOSS MODAL ══ */
function LossModal({client,onSave,onClose}){
  const [r,setR]=useState('');
  return(
    <Modal title="Marcar como Perdido" subtitle={client?.name} onClose={onClose}>
      <div style={{background:'#fef2f2',borderRadius:10,padding:'10px 14px',marginBottom:12,fontSize:12,color:'#dc2626'}}>
        ️ Esta acción marcará al cliente como perdido y quedará registrado en las estadísticas.
      </div>
      <Field label="CONCEPTO (describe con tus propias palabras)">
        <textarea value={r} onChange={e=>setR(e.target.value)}
          placeholder="Ej: El cliente eligió a la competencia por mejor precio, No tenía presupuesto suficiente, No le convenció el producto..."
          rows={4} style={{...inp,resize:'none',marginBottom:14,marginTop:6}}/>
      </Field>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>r.trim()&&onSave(r)} disabled={!r.trim()}
          style={{flex:2,...btn_primary,background:r.trim()?'#ef4444':'#f1f5f9',color:r.trim()?'#fff':'#94a3b8',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
          <XCircle size={14}/> Confirmar pérdida
        </button>
      </div>
    </Modal>
  );
}

/* ══ WIN MODAL — con valor de venta ══ */
function WinModal({client,onSave,onClose}){
  const [amount,setAmount]=useState('');
  const [concept,setConcept]=useState('');
  const [notes,setNotes]=useState('');
  return(
    <Modal title="¡Marcar como Ganado! " subtitle={client?.name} onClose={onClose}>
      <div style={{background:'#f0fdf4',borderRadius:10,padding:'10px 14px',marginBottom:14,fontSize:12,color:'#16a34a'}}>
        ¡Excelente! Registra el valor de esta venta para llevar estadísticas reales del negocio.
      </div>
      <div style={{display:'grid',gap:10,marginBottom:16}}>
        <Field label="VALOR DE LA VENTA ($)" required>
          <input type="number" value={amount} onChange={e=>setAmount(e.target.value)}
            placeholder="Ej: 5000.00" style={inp}/>
        </Field>
        <Field label="CONCEPTO / PRODUCTO VENDIDO">
          <input value={concept} onChange={e=>setConcept(e.target.value)}
            placeholder="Ej: Plan Professional mensual, Producto XYZ..." style={inp}/>
        </Field>
        <Field label="NOTAS DE LA VENTA">
          <textarea value={notes} onChange={e=>setNotes(e.target.value)}
            placeholder="Notas adicionales sobre este cierre..." rows={2}
            style={{...inp,resize:'none'}}/>
        </Field>
      </div>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>onSave({amount:parseFloat(amount)||0, concept, notes})}
          style={{flex:2,...btn_primary,background:'#10b981',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}>
          <CheckCircle size={14}/> Confirmar venta
        </button>
      </div>
    </Modal>
  );
}

/* ══ CLIENT MODAL ══ */
function ClientModal({client,onSave,onClose}){
  // Sin score: el asesor solo elige el estado (Cierre / Seguimiento / Frío) y el backend deriva el score.
  const [f,setF]=useState(client?{name:client.name,phone:client.phone,email:client.email||'',cedula:client.cedula||'',heat:client.heat||'tibio',notes:client.notes||'',producto:client.producto||''}:{name:'',phone:'',email:'',cedula:'',heat:'tibio',notes:'',producto:''});
  return(
    <Modal title={client?'Editar cliente':'Nuevo cliente'} width={460} onClose={onClose}>
        <div style={{display:'grid',gap:10,marginBottom:16}}>
          {[{p:'Nombre completo *',k:'name',t:'text'},{p:'Teléfono *',k:'phone',t:'tel'},{p:'Email',k:'email',t:'email'},{p:'Cédula / RUC',k:'cedula',t:'text'}].map(fi => (





          <input key={fi.k} type={fi.t} value={f[fi.k]} onChange={e=>setF(p=>({...p,[fi.k]:e.target.value}))} placeholder={fi.p} style={inp}/>
        ))}
        <Field label="ESTADO DEL CLIENTE">
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginTop:2}}>
            {Object.entries(HEAT).map(([k,v])=>(
              <button key={k} onClick={()=>setF(p=>({...p,heat:k}))} style={{padding:'11px 4px',borderRadius:9,border:`2px solid ${f.heat===k?v.c:'#e2e8f0'}`,background:f.heat===k?v.b:'#fafafa',cursor:'pointer',fontSize:13,fontWeight:700,color:f.heat===k?v.c:'#94a3b8',textAlign:'center'}}>
                {ESTADO_NOMBRE[k]}
              </button>
            ))}
          </div>
        </Field>
        <textarea value={f.notes} onChange={e=>setF(p=>({...p,notes:e.target.value}))} placeholder="Notas sobre el cliente..." rows={3} style={{...inp,resize:'none'}}/>
        <Field label="PRODUCTO / SERVICIO">
          <select value={f.producto} onChange={e=>setF(p=>({...p,producto:e.target.value}))} style={inp}>
            <option value="">— Sin asignar —</option>
            <option value="Estrella">⭐ Estrella</option>
            <option value="Súper Estrella">⭐⭐ Súper Estrella</option>
            <option value="Mega Estrella">⭐⭐⭐ Mega Estrella</option>
            <option value="Contado">💵 Contado</option>
          </select>
        </Field>
      </div>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>{if(!f.name||!f.phone){alert('Nombre y teléfono son obligatorios');return;}onSave(f);}} style={{flex:2,...btn_primary}}>
          <Save size={14}/> {client?'Guardar cambios':'Agregar cliente'}
        </button>
      </div>
    </Modal>
  );
}

/* ══ EVENT MODAL ══ */
function EventModal({clients,ev,onSave,onClose}){
  const [f,setF]=useState(ev?{type:ev.type,cid:ev.cid,date:ev.date,time:ev.time,notes:ev.notes}:{type:'cita',cid:'',date:dateStr(1),time:'10:00',notes:''});
  return(
    <Modal title={ev?'Editar evento':'Nuevo evento'} width={460} onClose={onClose}>
      <div style={{display:'grid',gap:10,marginBottom:16}}>
        <Field label="TIPO DE EVENTO">
          <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginTop:2}}>
            {Object.entries(EVT_CFG).map(([k,v])=>(
              <button key={k} onClick={()=>setF(p=>({...p,type:k}))} style={{padding:'8px 4px',borderRadius:8,border:`2px solid ${f.type===k?v.color:'#e2e8f0'}`,background:f.type===k?`${v.color}12`:'#fafafa',cursor:'pointer',fontSize:10,fontWeight:700,color:f.type===k?v.color:'#9aa5be',textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center',gap:3}}>
                <v.Icon size={14}/>{v.label.split(' ')[0]}
              </button>
            ))}
          </div>
        </Field>
        <Field label="CLIENTE">
          <select value={f.cid} onChange={e=>setF(p=>({...p,cid:e.target.value}))} style={inp}>
            <option value="">-- Selecciona un cliente --</option>
            {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </Field>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10}}>
          <Field label="FECHA"><input type="date" value={f.date} onChange={e=>setF(p=>({...p,date:e.target.value}))} style={inp}/></Field>
          <Field label="HORA"><input type="time" value={f.time} onChange={e=>setF(p=>({...p,time:e.target.value}))} style={inp}/></Field>
        </div>
        <textarea value={f.notes} onChange={e=>setF(p=>({...p,notes:e.target.value}))} placeholder="Notas del evento..." rows={2} style={{...inp,resize:'none'}}/>
      </div>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>{if(!f.cid){alert('Selecciona un cliente');return;}const cl=clients.find(c=>c.id===f.cid);onSave({...f,cname:cl?.name||''});}} style={{flex:2,...btn_primary}}>
          <Save size={14}/> {ev?'Guardar cambios':'Crear evento'}
        </button>
      </div>
    </Modal>
  );
}

/* ══ ACTION EDIT MODAL ══ */
function ActionModal({action,onSave,onClose}){
  const [f,setF]=useState({type:action.type,resultado:action.resultado||'',notas:action.notas||''});
  return(
    <Modal title="Editar actividad" subtitle={action.cname} width={440} onClose={onClose}>
      <div style={{display:'grid',gap:10,marginBottom:16}}>
        <Field label="TIPO">
          <select value={f.type} onChange={e=>setF(p=>({...p,type:e.target.value}))} style={inp}>
            <option value="llamada">Llamada telefónica</option>
            <option value="whatsapp">WhatsApp</option>
            <option value="email">Email</option>
            <option value="cita">Cita / visita</option>
          </select>
        </Field>
        <Field label="RESULTADO">
          <input value={f.resultado} onChange={e=>setF(p=>({...p,resultado:e.target.value}))} placeholder="¿Qué resultado tuvo?" style={inp}/>
        </Field>
        <Field label="NOTAS INTERNAS">
          <textarea value={f.notas} onChange={e=>setF(p=>({...p,notas:e.target.value}))} rows={3} style={{...inp,resize:'none'}}/>
        </Field>
      </div>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>onSave(f)} style={{flex:2,...btn_primary}}><Save size={14}/> Guardar</button>
      </div>
    </Modal>
  );
}


/* ══ LEAD MODAL ══ */

/* ════════════════════════════════════════════
   TAB CLIENTES — con clasificación Caliente/Tibio/Frío
════════════════════════════════════════════ */
function TabClientes({clients,setClients,onCall,onRefresh,onVerConversacion,initialId,onInitialDone}){
  const [isMob, setIsMob] = useState(window.innerWidth < 900);
  useEffect(()=>{const fn=()=>setIsMob(window.innerWidth<900);window.addEventListener('resize',fn);return()=>window.removeEventListener('resize',fn);},[]);
  const [q,setQ]=useState(''); const [filt,setFilt]=useState('all'); const [heatFilt,setHeatFilt]=useState('all');
  const [lossModal,  setLossModal]  = useState(null);
  const [winModal,   setWinModal]   = useState(null);
  const [clientModal,setClientModal]= useState(null);
  const [detailId,   setDetailId]   = useState(null);
  const [saving,     setSaving]     = useState(false);
  useEffect(()=>{ if(initialId){ setDetailId(initialId); onInitialDone && onInitialDone(); } },[initialId]);

  // Reasignado = el supervisor le pasó este cliente al asesor (marca que pone el backend)
  const esReasignado = c => !!(c.metadata?.reassigned_at);

  const rows=clients.filter(c=>{
    const ms=(c.name||'').toLowerCase().includes(q.toLowerCase())||(c.phone||'').includes(q);
    const mf=filt==='all'||(filt==='active'&&!c.result)||(filt==='won'&&c.result==='won')||(filt==='lost'&&c.result==='lost')||(filt==='reasignado'&&esReasignado(c));
    const mh=heatFilt==='all'||c.heat===heatFilt;
    return ms&&mf&&mh;
  });

  const ESTADOS=[
    {v:'all',       l:'Todos',      c:DS.primary, n:clients.length},
    {v:'active',    l:'En proceso', c:'#f59e0b', n:clients.filter(c=>!c.result).length},
    {v:'won',       l:'Ganado',     c:'#10b981', n:clients.filter(c=>c.result==='won').length},
    {v:'lost',      l:'Perdido',    c:'#ef4444', n:clients.filter(c=>c.result==='lost').length},
    {v:'reasignado',l:'Reasignado', c:'#2563eb', n:clients.filter(esReasignado).length},
  ];

  const { paged, ...pg } = usePaged(rows, 12);

  async function markWon(id, winData) {
    try {
      await apiFetch('PUT',`/api/asesor/clients/${id}`,{
        result:'won', heat:'caliente',
        notes: winData?.notes||'',
        saleAmount: winData?.amount||0,
        saleConcept: winData?.concept||'',
      });
      setClients(p=>p.map(c=>c.id===id?{...c,result:'won',saleAmount:winData?.amount||0}:c));
      // Registrar la venta en actividades del equipo
      if (winData?.amount>0) {
        apiFetch('POST','/api/asesor/activities',{
          clientId:id, type:'venta',
          resultado:`Venta cerrada: ${winData.concept||'Venta'} — $${winData.amount}`,
          notas:winData.notes||'', duration:0,
        }).catch(()=>{});
      }
    } catch(e) { alert('Error: '+e.message); }
    setWinModal(null); setDetailId(null);
  }

  async function markLost(id,r) {
    try {
      await apiFetch('PUT',`/api/asesor/clients/${id}`,{ result:'lost', lossReason:r });
      setClients(p=>p.map(c=>c.id===id?{...c,result:'lost',lossReason:r}:c));
    } catch(e) { alert('Error: '+e.message); }
    setLossModal(null); setDetailId(null);
  }

  async function reopen(id) {
    try {
      await apiFetch('PUT',`/api/asesor/clients/${id}`,{ result:null });
      setClients(p=>p.map(c=>c.id===id?{...c,result:null,lossReason:''}:c));
    } catch(e) { alert('Error: '+e.message); }
  }

  function del(id) {
    askConfirm('Este cliente será eliminado permanentemente.', async () => {
      try {
        await apiFetch('DELETE',`/api/clients/${id}`);
        setClients(p=>p.filter(c=>c.id!==id));
      } catch(e) { alert('Error: '+e.message); }
      setDetailId(null);
    });
  }

  async function save(f) {
    setSaving(true);
    try {
      if(clientModal==='new') {
        const r = await apiFetch('POST','/api/clients',{
          name:f.name, phone:f.phone, email:f.email||null, cedula:f.cedula||null,
          notes:f.notes||null, heat:f.heat, classification:'needs_info',
        });
        setClients(p=>[{...r,heat:f.heat,cedula:f.cedula||'',result:null,last:r.created_at},...p]);
      } else {
        // sin score: el backend lo deriva del estado (heat) y sincroniza el lead vinculado
        const r = await apiFetch('PUT',`/api/asesor/clients/${clientModal.id}`,{
          name:f.name, phone:f.phone, email:f.email, cedula:f.cedula, notes:f.notes, heat:f.heat, producto:f.producto,
        });
        setClients(p=>p.map(c=>c.id===clientModal.id?{...c,...r,heat:f.heat,cedula:f.cedula||''}:c));
      }
      if(onRefresh) onRefresh();
    } catch(e) { alert('Error: '+e.message); }
    setSaving(false);
    setClientModal(null);
  }

  const dc=detailId?clients.find(c=>c.id===detailId):null;

  const sidebarPanels = (
    <>
      <Panel title="Distribución de calor" Icon={TrendingUp}>
        {Object.entries(HEAT).map(([k,v])=>{
          const n=clients.filter(c=>c.heat===k).length; const pct=clients.length?Math.round((n/clients.length)*100):0;
          return(
            <div key={k} style={{marginBottom:10}}>
              <div style={{display:'flex',justifyContent:'space-between',marginBottom:3,fontSize:11,fontWeight:700,color:'#4a5568'}}>
                <span>{v.l}</span><span style={{color:v.c}}>{n}</span>
              </div>
              <div style={{background:'rgba(var(--primary-rgb),0.10)',borderRadius:999,height:6}}><div style={{width:`${pct}%`,height:'100%',background:v.c,borderRadius:999}}/></div>
            </div>
          );
        })}
      </Panel>
      <Panel title="Sin contacto +24h" Icon={AlertCircle} color="#ef4444">
        {clients.filter(c=>(Date.now()-new Date(c.last))/3600000>24&&!c.result).map(c=>(
          <div key={c.id} style={{display:'flex',gap:7,padding:'7px 0',borderBottom:'1px solid #e2e8f0',alignItems:'center'}}>
            <div style={{flex:1}}><div style={{fontSize:11,fontWeight:700,color:'var(--dark,#0f172a)'}}>{c.name}</div><div style={{fontSize:9,color:'#ef4444'}}>{ago(c.last)}</div></div>
            <IBtn onClick={()=>onCall(c)}><Phone size={11} color={DS.primary}/></IBtn>
          </div>
        ))}
        {clients.filter(c=>(Date.now()-new Date(c.last))/3600000>24&&!c.result).length===0&&<div style={{fontSize:11,color:'#10b981',textAlign:'center',fontWeight:600}}> Todos contactados</div>}
      </Panel>
    </>
  );

  return(
    <div>
    <div style={{display:'flex',flexDirection:isMob?'column':'row',gap:16}}>
      {lossModal&&<LossModal client={lossModal} onSave={r=>markLost(lossModal.id,r)} onClose={()=>setLossModal(null)}/>}
      {winModal&&<WinModal client={winModal} onSave={d=>markWon(winModal.id,d)} onClose={()=>setWinModal(null)}/>}
      {clientModal&&<ClientModal client={clientModal==='new'?null:clientModal} onSave={save} onClose={()=>setClientModal(null)}/>}
      {dc&&(
        <div style={{position:'fixed',inset:0,backdropFilter:'blur(6px)',background:'rgba(var(--primary-rgb),0.3)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9000}}>
          <div style={{background:'#ffffff',borderRadius:20,padding:26,width:480,maxHeight:'85vh',overflowY:'auto',boxShadow:'0 20px 60px rgba(0,0,0,0.25)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:14}}>
              <div>
                <h2 style={{margin:'0 0 6px',fontSize:18,fontWeight:800,color:'var(--dark,#0f172a)'}}>{dc.name}</h2>
                <div style={{display:'flex',gap:6,flexWrap:'wrap',alignItems:'center'}}>
                  {dc.heat&&(
                    <span style={{display:'inline-flex',alignItems:'center',gap:4,
                      padding:'2px 8px',borderRadius:999,fontSize:10,fontWeight:700,
                      color:HEAT[dc.heat]?.c||'#94a3b8',
                      background:HEAT[dc.heat]?.b||'#f1f5f9',
                      border:`1px solid ${HEAT[dc.heat]?.c||'#94a3b8'}25`}}>
                      <span style={{width:6,height:6,borderRadius:'50%',
                        background:HEAT[dc.heat]?.c||'#94a3b8',
                        boxShadow:`0 0 5px ${HEAT[dc.heat]?.c||'#94a3b8'}`,flexShrink:0}}/>
                      {HEAT[dc.heat]?.l||dc.heat}
                    </span>
                  )}
                  {dc.result==='won'&&<Bdg l=" Ganado" c="#065f46" b="#d1fae5"/>}
                  {dc.result==='lost'&&<Bdg l=" Perdido" c="#7f1d1d" b="#fee2e2"/>}
                  {!dc.result&&<Bdg l="● En proceso" c="#92400e" b="#fef3c7"/>}
                  {esReasignado(dc)&&<Bdg l="🔄 Reasignado" c="#1e40af" b="#dbeafe"/>}
                </div>
              </div>
              <button onClick={()=>setDetailId(null)} style={{border:'none',background:'rgba(var(--primary-rgb),0.10)',borderRadius:8,padding:7,cursor:'pointer',display:'flex'}}><X size={13} color="#64748b"/></button>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:12}}>
              {[{l:'TELÉFONO',v:dc.phone},{l:'CÉDULA / RUC',v:dc.cedula||'—'},{l:'EMAIL',v:dc.email||'—'},{l:'SCORE',v:`${dc.score}/100`},{l:'CONTACTO',v:ago(dc.last)}].map((fi,i)=>(
                <div key={i} style={{background:'#f5f7fb',borderRadius:9,padding:'9px 12px'}}>
                  <div style={{fontSize:9,color:'#9aa5be',fontWeight:700}}>{fi.l}</div>
                  <div style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)',marginTop:3}}>{fi.v}</div>
                </div>
              ))}
            </div>
            {esReasignado(dc)&&<div style={{background:'#eff6ff',borderRadius:9,padding:'9px 12px',border:'1px solid #bfdbfe',marginBottom:12,fontSize:12,color:'#1e40af'}}>
              🔄 Cliente reasignado{dc.metadata?.reassigned_by?` por ${dc.metadata.reassigned_by}`:''} · {ago(dc.metadata.reassigned_at)}
            </div>}
            {dc.notes&&<div style={{background:'#fef3c7',borderRadius:9,padding:'9px 12px',marginBottom:12,fontSize:13,color:'#92400e'}}><b>Nota:</b> {dc.notes}</div>}
            {dc.result==='won'&&dc.saleAmount>0&&<div style={{background:'#f0fdf4',borderRadius:9,padding:'9px 12px',border:'1px solid #bbf7d0',marginBottom:12}}><div style={{fontSize:9,color:'#16a34a',fontWeight:700,marginBottom:3}}>VALOR DE VENTA</div><div style={{fontSize:18,fontWeight:800,color:'#16a34a'}}>${parseFloat(dc.saleAmount||0).toLocaleString()}</div></div>}
            {(dc.producto||dc.metadata?.producto)&&<div style={{background:'#eff6ff',borderRadius:9,padding:'9px 12px',border:'1px solid #bfdbfe',marginBottom:12}}><div style={{fontSize:9,color:'#1d4ed8',fontWeight:700,marginBottom:3}}>PRODUCTO / SERVICIO</div><div style={{fontSize:13,fontWeight:700,color:'#1e40af'}}>{dc.producto||dc.metadata?.producto}</div></div>}
            {dc.result==='lost'&&<div style={{background:'#fef2f2',borderRadius:9,padding:'9px 12px',border:'1px solid #fecaca',marginBottom:12}}><div style={{fontSize:9,color:'#dc2626',fontWeight:700,marginBottom:3}}>CONCEPTO</div><div style={{fontSize:12,color:'#7f1d1d'}}>{dc.lossReason||'Sin concepto registrado'}</div></div>}
            <div style={{display:'flex',gap:7,flexWrap:'wrap'}}>
              <IBtn onClick={()=>onCall(dc)} bg="#eef2ff" color={DS.primary}><Phone size={12}/> Llamar</IBtn>
              {onVerConversacion&&<IBtn onClick={()=>{setDetailId(null);onVerConversacion(dc);}} bg="#eff6ff" color="#2563eb"><MessageSquare size={12}/> Ver conversación</IBtn>}
              <IBtn onClick={()=>askWhatsApp(dc.phone, `Hola ${dc.name}`)} bg="#f0fdf4" color="#25d366"><MessageCircle size={12}/> WhatsApp</IBtn>
              <IBtn onClick={()=>{setDetailId(null);setClientModal(dc);}} bg="#fef3c7" color="#d97706"><Edit2 size={12}/> Editar</IBtn>
              {!dc.result&&<><IBtn onClick={()=>{setWinModal(dc);}} bg="#d1fae5" color="#10b981"><CheckCircle size={12}/> Ganado</IBtn><IBtn onClick={()=>{setDetailId(null);setLossModal(dc);}} bg="#fee2e2" color="#ef4444"><XCircle size={12}/> Perdido</IBtn></>}
              {dc.result&&<IBtn onClick={()=>reopen(dc.id)} bg="#f1f5f9" color="#64748b"><RefreshCw size={12}/> Reabrir</IBtn>}
              <IBtn onClick={()=>del(dc.id)} bg="#fee2e2" color="#ef4444"><Trash2 size={12}/> Eliminar</IBtn>
            </div>
          </div>
        </div>
      )}

      <div style={{flex:1,minWidth:0}}>
        {/* Pestañas por estado */}
        <div style={{display:'flex',gap:8,marginBottom:10,overflowX:'auto',WebkitOverflowScrolling:'touch',paddingBottom:2}}>
          {ESTADOS.map(s=>(
            <button key={s.v} onClick={()=>setFilt(s.v)}
              style={{padding:'7px 14px',borderRadius:9,border:'none',cursor:'pointer',whiteSpace:'nowrap',
                fontSize:12,fontWeight:700,display:'flex',alignItems:'center',gap:6,
                background:filt===s.v?s.c:'#f1f5f9',color:filt===s.v?'#fff':'#64748b'}}>
              {s.l}
              <span style={{fontSize:11,fontWeight:800,padding:'1px 6px',borderRadius:999,
                background:filt===s.v?'rgba(255,255,255,0.25)':'#fff',color:filt===s.v?'#fff':s.c}}>{s.n}</span>
            </button>
          ))}
        </div>

        {/* Filtros de temperatura */}
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:8,marginBottom:12}}>
          {[{l:'Todos',v:'all',c:DS.primary,n:clients.length,Ic:null},{l:'Caliente',v:'caliente',c:'#ef4444',n:clients.filter(c=>c.heat==='caliente').length,Ic:Flame},{l:'Tibio',v:'tibio',c:'#f59e0b',n:clients.filter(c=>c.heat==='tibio').length,Ic:Thermometer},{l:'Frío',v:'frio',c:DS.primary,n:clients.filter(c=>c.heat==='frio').length,Ic:Snowflake}].map(s=>(
            <div key={s.v} onClick={()=>setHeatFilt(s.v)} style={{background:'var(--card-bg,#fff)', borderRadius:16,padding:'9px 12px',border:'1px solid #e5e7eb',borderLeft:`3px solid ${heatFilt===s.v?s.c:'transparent'}`,cursor:'pointer',textAlign:'center'}}>
              <div style={{fontSize:18,fontWeight:800,color:s.c}}>{s.n}</div>
              <div style={{fontSize:10,color:'#9aa5be',marginTop:2}}>{s.l}</div>
            </div>
          ))}
        </div>

        {/* Search + New */}
        <div style={{display:'flex',gap:8,marginBottom:12,overflowX:'auto',flexWrap:'nowrap',WebkitOverflowScrolling:'touch',paddingBottom:4}}>
          <div style={{flex:1,position:'relative',minWidth:150}}>
            <Search size={12} color="#94a3b8" style={{position:'absolute',left:10,top:'50%',transform:'translateY(-50%)'}}/>
            <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Buscar por nombre o teléfono..."
              style={{...inp,paddingLeft:30}}/>
          </div>
          <button onClick={()=>setClientModal('new')} style={{padding:'9px 16px',borderRadius:9,border:'none',background:DS.primary,color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',gap:5}}>
            <Plus size={13}/> Nuevo cliente
          </button>
        </div>

        {/* Tabla */}
        <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',overflowX:'auto'}}>
          <table style={{width:'100%',borderCollapse:'collapse',minWidth:680}}>
            <thead><tr style={{borderBottom:'1px solid #eef0f3'}}>{['Cliente','Teléfono','Temperatura','Estado','Score','Último contacto','Acciones'].map(h=><th key={h} style={{padding:'8px 11px',textAlign:'left',fontSize:12,fontWeight:600,color:'#94a3b8'}}>{h}</th>)}</tr></thead>
            <tbody>
              {paged.map(c=>{
                const h=HEAT[c.heat]||{l:c.heat,c:'#94a3b8',b:'#f1f5f9',Icon:null};
                return(
                  <tr key={c.id} style={{borderTop:'1px solid #e2e8f0',cursor:'pointer'}} onClick={()=>setDetailId(c.id)}>
                    <td style={{padding:'9px 11px'}}><div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{c.name}</div><div style={{fontSize:10,color:'#9aa5be'}}>{c.email||'Sin email'}</div></td>
                    <td style={{padding:'9px 11px',fontSize:12,color:'#4a5568'}}>{c.phone}</td>
                    <td style={{padding:'9px 11px'}}><Bdg l={h.l} c={h.c} b={h.b}/></td>
                    <td style={{padding:'9px 11px'}}>
                      {c.result==='won'&&<Bdg l=" Ganado" c="#065f46" b="#d1fae5"/>}
                      {c.result==='lost'&&<Bdg l=" Perdido" c="#7f1d1d" b="#fee2e2"/>}
                      {!c.result&&<Bdg l="● Proceso" c="#92400e" b="#fef3c7"/>}
                      {esReasignado(c)&&<Bdg l="🔄" c="#1e40af" b="#dbeafe"/>}
                    </td>
                    <td style={{padding:'9px 11px'}}><span style={{padding:'2px 8px',borderRadius:999,fontSize:11,fontWeight:700,color:c.score>=70?'#065f46':c.score>=40?'#92400e':'#7f1d1d',background:c.score>=70?'#d1fae5':c.score>=40?'#fef3c7':'#fee2e2'}}>{c.score}</span></td>
                    <td style={{padding:'9px 11px',fontSize:11,color:'#9aa5be'}}>{ago(c.last)}</td>
                    <td style={{padding:'9px 11px'}} onClick={e=>e.stopPropagation()}>
                      <div style={{display:'flex',gap:4}}>
                        <IBtn onClick={()=>setClientModal(c)} bg="#eef2ff"><Edit2 size={11} color={DS.primary}/></IBtn>
                        <IBtn onClick={()=>onCall(c)} bg="#f0fdf4"><Phone size={11} color="#10b981"/></IBtn>
                        {!c.result&&<IBtn onClick={()=>setWinModal(c)} bg="#d1fae5" title="Marcar como Ganado"><CheckCircle size={11} color="#10b981"/></IBtn>}
                        {!c.result&&<IBtn onClick={()=>setLossModal(c)} bg="#fee2e2" title="Marcar como Perdido"><XCircle size={11} color="#ef4444"/></IBtn>}
                        <IBtn onClick={()=>del(c.id)} bg="#fef2f2"><Trash2 size={11} color="#ef4444"/></IBtn>
                      </div>
                    </td>
                  </tr>
                );
              })}
              {!rows.length&&<tr><td colSpan={7} style={{padding:28,textAlign:'center',color:'#9aa5be',fontSize:13}}>Sin resultados</td></tr>}
            </tbody>
          </table>
        </div>
        <Pagination {...pg} primary={DS.primary} label="clientes" />
      </div>

      {/* Sidebar desktop */}
      {!isMob && (
        <div style={{width:220,flexShrink:0,display:'flex',flexDirection:'column',gap:12}}>
          {sidebarPanels}
        </div>
      )}
    </div>
    {/* Sidebar mobile — debajo de la lista */}
    {isMob && (
      <div style={{display:'flex',gap:12,marginTop:12}}>
        <div style={{flex:1}}>{sidebarPanels}</div>
      </div>
    )}
    </div>
  );
}

/* ════════════════════════════════════════════
   TAB CALENDARIO — CRUD completo, todos los tipos
════════════════════════════════════════════ */
/* ══ ACTIVIDAD FORM ══ */
function ActividadForm({act,clients,onSave,onClose}){
  const [f,setF]=useState({
    clientId:act?.client_id||act?.clientId||'',
    type:act?.type||'llamada',
    resultado:act?.resultado||'',
    notas:act?.notas||'',
    duration:act?.duration||act?.dur||0,
  });
  return(
    <div>
      <div style={{display:'grid',gap:10,marginBottom:16}}>
        <Field label="TIPO DE ACTIVIDAD">
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
            {[{k:'llamada',l:'Llamada',  Ic:Phone},{k:'whatsapp',l:'WhatsApp', Ic:MessageCircle},{k:'email',l:'Email',    Ic:FileText},{k:'cita',l:'Cita',     Ic:Calendar},{k:'venta',l:'Venta',    Ic:DollarSign},{k:'perdida',l:'Pérdida',  Ic:XCircle}].map(t=>(
              <button key={t.k} onClick={()=>setF(p=>({...p,type:t.k}))}
                style={{padding:'8px 4px',borderRadius:8,border:`2px solid ${f.type===t.k?DS.primary:'#e2e8f0'}`,background:f.type===t.k?'#eef2ff':'#fafafa',cursor:'pointer',fontSize:11,fontWeight:700,color:f.type===t.k?DS.primary:'#64748b'}}>
                {t.l}
              </button>
            ))}
          </div>
        </Field>
        <Field label="CLIENTE">
          <select value={f.clientId} onChange={e=>setF(p=>({...p,clientId:e.target.value}))} style={inp}>
            <option value="">-- Selecciona cliente --</option>
            {clients.map(c=><option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </Field>
        <Field label="RESULTADO">
          <input value={f.resultado} onChange={e=>setF(p=>({...p,resultado:e.target.value}))} placeholder="¿Qué resultado tuvo?" style={inp}/>
        </Field>
        <Field label="DURACIÓN (minutos)">
          <input type="number" value={f.duration} onChange={e=>setF(p=>({...p,duration:parseInt(e.target.value)||0}))} placeholder="0" style={{...inp,maxWidth:120}}/>
        </Field>
        <Field label="NOTAS INTERNAS">
          <textarea value={f.notas} onChange={e=>setF(p=>({...p,notas:e.target.value}))} rows={3} placeholder="Notas sobre la actividad..." style={{...inp,resize:'none'}}/>
        </Field>
      </div>
      <div style={{display:'flex',gap:10}}>
        <button onClick={onClose} style={{flex:1,...btn_cancel}}>Cancelar</button>
        <button onClick={()=>onSave(f)} style={{flex:2,...btn_primary}}><Save size={14}/> Guardar actividad</button>
      </div>
    </div>
  );
}

function TabCalendario({events,setEvents,clients,onRefresh}){
  const now=new Date();
  const [year,setYear]=useState(now.getFullYear());
  const [month,setMonth]=useState(now.getMonth());
  const [selDay,setSelDay]=useState(now.getDate());
  const [modal,setModal]=useState(null);
  const [actModal,setActModal]=useState(null); // null | 'new' | action-obj
  const [actions,setActions]=useState([]);
  const MNAMES=['Enero','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  const ACT_TYPES={llamada:'Llamada',whatsapp:'WhatsApp',email:'Email',    Ic:FileText,cita:'Cita',venta:'Venta',perdida:'Pérdida'};

  // Cargar actividades reales
  useEffect(()=>{
    apiFetch('GET','/api/asesor/activities').then(r=>{ if(Array.isArray(r)) setActions(r.map(a=>({...a,cname:a.client_name||'—',at:a.created_at}))); }).catch(()=>{});
  },[]);

  const daysInMonth=new Date(year,month+1,0).getDate();
  const firstDay=new Date(year,month,1).getDay();
  const evByDay={};
  events.forEach(e=>{const d=new Date(e.date);if(d.getFullYear()===year&&d.getMonth()===month){const k=d.getDate();if(!evByDay[k])evByDay[k]=[];evByDay[k].push(e);}});
  const todayStr=`${year}-${String(month+1).padStart(2,'0')}-${String(selDay).padStart(2,'0')}`;
  const dayEvts=events.filter(e=>e.date===todayStr).sort((a,b)=>(a.time||'').localeCompare(b.time||''));
  const upcoming=events.filter(e=>new Date(e.date)>=now).sort((a,b)=>new Date(a.date+' '+(a.time||''))-new Date(b.date+' '+(b.time||''))).slice(0,8);

  async function delEv(id){
    try{ await apiFetch('PUT',`/api/asesor/calendar/${id}`,{done:true}); setEvents(p=>p.filter(e=>e.id!==id)); }
    catch(e){ setEvents(p=>p.filter(e=>e.id!==id)); }
  }
  async function saveEv(f){
    try{
      if(modal==='new'){
        const r=await apiFetch('POST','/api/asesor/calendar',{clientId:f.cid,clientName:f.cname,type:f.type,eventDate:f.date,eventTime:f.time,notes:f.notes});
        setEvents(p=>[...p,{...r,date:r.event_date,time:r.event_time||'',cname:r.client_name||''}]);
      } else {
        await apiFetch('PUT',`/api/asesor/calendar/${modal.id}`,{notes:f.notes,eventDate:f.date,eventTime:f.time});
        setEvents(p=>p.map(e=>e.id===modal.id?{...e,...f}:e));
      }
    } catch(e){ setEvents(p=>modal==='new'?[...p,{id:'ev'+Date.now(),...f}]:p.map(e=>e.id===modal.id?{...e,...f}:e)); }
    setModal(null);
  }

  async function saveAction(f){
    try{
      if(actModal==='new'){
        const r=await apiFetch('POST','/api/asesor/activities',{clientId:f.clientId,type:f.type,resultado:f.resultado,notas:f.notas,duration:f.duration||0});
        setActions(p=>[{...r,cname:clients.find(c=>c.id===f.clientId)?.name||'—',at:r.created_at},...p]);
      } else {
        await apiFetch('PUT',`/api/asesor/activities/${actModal.id}`,{clientId:f.clientId,type:f.type,resultado:f.resultado,notas:f.notas,duration:f.duration});
        setActions(p=>p.map(a=>a.id===actModal.id?{...a,...f}:a));
      }
    } catch(e){ alert(e.message); }
    setActModal(null);
  }
  function delAction(id){
    askConfirm('Esta actividad será eliminada permanentemente.', async ()=>{
      try{ await apiFetch('DELETE',`/api/asesor/activities/${id}`); }
      catch(e){ alert(e.message); return; }
      setActions(p=>p.filter(a=>a.id!==id));
    });
  }

  return(
    <div style={{display:'grid',gridTemplateColumns:MOB?'1fr':'1fr 270px',gap:16}}>
      {modal&&<EventModal clients={clients} ev={modal==='new'?null:modal} onSave={saveEv} onClose={()=>setModal(null)}/>}
      <div>
        {/* Calendario visual */}
        <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',padding:18,marginBottom:14}}>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
            <button onClick={()=>{if(month===0){setMonth(11);setYear(y=>y-1);}else setMonth(m=>m-1);}} style={{border:'none',background:'rgba(var(--primary-rgb),0.10)',borderRadius:8,padding:'6px 10px',cursor:'pointer',display:'flex'}}><ChevronLeft size={14}/></button>
            <span style={{fontSize:15,fontWeight:800,color:'var(--dark,#0f172a)'}}>{MNAMES[month]} {year}</span>
            <button onClick={()=>{if(month===11){setMonth(0);setYear(y=>y+1);}else setMonth(m=>m+1);}} style={{border:'none',background:'rgba(var(--primary-rgb),0.10)',borderRadius:8,padding:'6px 10px',cursor:'pointer',display:'flex'}}><ChevronRight size={14}/></button>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2,marginBottom:4}}>
            {['D','L','M','X','J','V','S'].map(d=><div key={d} style={{textAlign:'center',fontSize:10,fontWeight:700,color:'#9aa5be',padding:'4px 0'}}>{d}</div>)}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2}}>
            {Array.from({length:firstDay}).map((_,i)=><div key={'e'+i}/>)}
            {Array.from({length:daysInMonth}).map((_,i)=>{
              const d=i+1;const isToday=d===now.getDate()&&month===now.getMonth()&&year===now.getFullYear();
              const isSel=d===selDay;const dayEvArr=evByDay[d]||[];
              return(
                <div key={d} onClick={()=>setSelDay(d)} style={{padding:'6px 0',borderRadius:8,textAlign:'center',cursor:'pointer',background:isToday?DS.primary:isSel?'#eef2ff':'transparent',color:isToday?'#fff':isSel?DS.primary:'#374151',fontWeight:isToday||isSel?800:400,position:'relative',fontSize:12}}>
                  {d}
                  {dayEvArr.length>0&&(
                    <div style={{position:'absolute',bottom:1,left:'50%',transform:'translateX(-50%)',display:'flex',gap:2}}>
                      {dayEvArr.slice(0,3).map((e,i)=>{const cfg=EVT_CFG[e.type]||{color:DS.primary};return<div key={i} style={{width:4,height:4,borderRadius:'50%',background:isToday?'#fff':cfg.color}}/>;})}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Leyenda de tipos */}
        <div style={{display:'flex',gap:10,marginBottom:12,flexWrap:'wrap'}}>
          {Object.entries(EVT_CFG).map(([k,v])=>(
            <div key={k} style={{display:'flex',alignItems:'center',gap:5,padding:'5px 10px',background:'#ffffff',borderRadius:8,border:'1px solid #e2e8f0',fontSize:11,fontWeight:600,color:v.color}}>
              <v.Icon size={11}/>{v.label}
            </div>
          ))}
        </div>

        {/* Eventos del día seleccionado */}
        <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',overflow:'hidden'}}>
          <div style={{padding:'11px 16px',borderBottom:'1px solid #e2e8f0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{selDay} de {MNAMES[month]} · {dayEvts.length} evento(s)</span>
            <button onClick={()=>setModal('new')} style={{padding:'6px 12px',borderRadius:8,border:'none',background:DS.primary,color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:4}}><Plus size={11}/> Agregar</button>
          </div>
          {dayEvts.length===0&&<div style={{padding:24,textAlign:'center',color:'#9aa5be',fontSize:12}}>Sin eventos este día. <button onClick={()=>setModal('new')} style={{background:'none',border:'none',color:DS.primary,fontWeight:700,cursor:'pointer',fontSize:12}}>+ Crear uno</button></div>}
          {dayEvts.map(e=>{const cfg=EVT_CFG[e.type]||{Icon:Calendar,label:e.type,color:DS.primary};return(
            <div key={e.id} style={{display:'flex',gap:12,padding:'12px 16px',borderBottom:'1px solid #e2e8f0',alignItems:'center'}}>
              <div style={{width:36,height:36,borderRadius:9,background:`${cfg.color}15`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><cfg.Icon size={16} color={cfg.color}/></div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{e.cname}</div>
                <div style={{fontSize:11,color:cfg.color,fontWeight:700}}>{e.time} · {cfg.label}</div>
                {e.notes&&<div style={{fontSize:11,color:'#9aa5be',marginTop:2}}>{e.notes}</div>}
              </div>
              <div style={{display:'flex',gap:5}}>
                <IBtn onClick={()=>setModal(e)} bg="#eef2ff"><Edit2 size={11} color={DS.primary}/></IBtn>
                <IBtn onClick={()=>askWhatsApp(clients.find(c=>c.id===e.cid)?.phone, `Recordatorio de ${cfg.label} hoy a las ${e.time}`)} bg="#f0fdf4"><MessageCircle size={11} color="#25d366"/></IBtn>
                <IBtn onClick={()=>delEv(e.id)} bg="#fef2f2"><Trash2 size={11} color="#ef4444"/></IBtn>
              </div>
            </div>
          );})}
        </div>
      </div>

      {/* Sidebar próximos */}
      <div style={{display:'flex',flexDirection:'column',gap:12}}>
        <button onClick={()=>setModal('new')} style={{width:'100%',padding:'11px',borderRadius:12,border:'none',background:DS.primary,color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}><Plus size={14}/> Nuevo evento</button>
        <button onClick={()=>setActModal('new')} style={{width:'100%',padding:'11px',borderRadius:12,border:'none',background:'#10b981',color:'#fff',fontWeight:700,fontSize:13,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',gap:6}}><Plus size={14}/> Nueva actividad</button>

        {/* Stats por tipo */}
        <Panel title="Por tipo" Icon={Activity} color="#8b5cf6">
          {Object.entries(EVT_CFG).map(([k,v])=>{const n=events.filter(e=>e.type===k).length;return(
            <div key={k} style={{display:'flex',alignItems:'center',gap:8,marginBottom:9}}>
              <div style={{width:28,height:28,borderRadius:7,background:`${v.color}15`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><v.Icon size={12} color={v.color}/></div>
              <div style={{flex:1}}><div style={{fontSize:11,fontWeight:600,color:'#4a5568'}}>{v.label}</div></div>
              <span style={{fontSize:14,fontWeight:800,color:v.color}}>{n}</span>
            </div>
          );})}
        </Panel>

        <Panel title="Próximos eventos" Icon={Bell} color="#f59e0b">
          {upcoming.length===0&&<div style={{fontSize:11,color:'#9aa5be',textAlign:'center',padding:8}}>Sin eventos próximos</div>}
          {upcoming.map(e=>{const cfg=EVT_CFG[e.type]||{Icon:Calendar,color:DS.primary,label:e.type};return(
            <div key={e.id} style={{display:'flex',gap:8,padding:'8px 0',borderBottom:'1px solid #e2e8f0',alignItems:'flex-start'}}>
              <div style={{width:28,height:28,borderRadius:7,background:`${cfg.color}15`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><cfg.Icon size={12} color={cfg.color}/></div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,fontWeight:700,color:'var(--dark,#0f172a)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{e.cname}</div>
                <div style={{fontSize:10,color:cfg.color,fontWeight:700}}>{e.date} · {e.time}</div>
                <div style={{fontSize:9,color:'#9aa5be'}}>{cfg.label}</div>
              </div>
              <button onClick={()=>delEv(e.id)} style={{border:'none',background:'#fef2f2',borderRadius:6,padding:'4px 5px',cursor:'pointer',display:'flex',flexShrink:0}}><Trash2 size={10} color="#ef4444"/></button>
            </div>
          );})}
        </Panel>
      </div>

      {/* Lista de actividades — parte inferior completa */}
      <div style={{gridColumn:'1/-1',background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',overflowX:'auto',marginTop:4}}>
        <div style={{padding:'12px 16px',borderBottom:'1px solid #e2e8f0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)',display:'flex',alignItems:'center',gap:6}}><Activity size={13} color={DS.primary}/> Mis actividades ({actions.length})</span>
          <button onClick={()=>setActModal('new')} style={{padding:'6px 12px',borderRadius:8,border:'none',background:'#10b981',color:'#fff',fontSize:11,fontWeight:700,cursor:'pointer',display:'flex',alignItems:'center',gap:4}}><Plus size={11}/> Nueva</button>
        </div>
        {actions.length===0&&<div style={{padding:20,textAlign:'center',color:'#9aa5be',fontSize:12}}>Sin actividades registradas. Crea una con el botón "+ Nueva"</div>}
        <table style={{width:'100%',borderCollapse:'collapse',minWidth:680}}>
          <thead><tr style={{borderBottom:'1px solid #eef0f3'}}>{['Tipo','Cliente','Resultado','Notas','Fecha','Acciones'].map(h=><th key={h} style={{padding:'7px 12px',textAlign:'left',fontSize:12,fontWeight:600,color:'#94a3b8'}}>{h}</th>)}</tr></thead>
          <tbody>
            {actions.slice(0,30).map(a=>{
              const color={llamada:DS.primary,whatsapp:'#25d366',email:'#0ea5e9',cita:'#f59e0b',venta:'#10b981',perdida:'#ef4444'}[a.type]||'#94a3b8';
              return(
                <tr key={a.id} style={{borderTop:'1px solid #e2e8f0'}}>
                  <td style={{padding:'9px 12px'}}><span style={{padding:'2px 9px',borderRadius:999,fontSize:11,fontWeight:700,color,background:`${color}18`}}>{ACT_TYPES[a.type]||a.type}</span></td>
                  <td style={{padding:'9px 12px',fontSize:12,fontWeight:600,color:'#4a5568'}}>{a.cname||a.client_name||'—'}</td>
                  <td style={{padding:'9px 12px',fontSize:11,color:'#9aa5be'}}>{a.resultado||'—'}</td>
                  <td style={{padding:'9px 12px',fontSize:11,color:'#9aa5be',maxWidth:180,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.notas||'—'}</td>
                  <td style={{padding:'9px 12px',fontSize:10,color:'#9aa5be',whiteSpace:'nowrap'}}>{a.at?new Date(a.at).toLocaleDateString('es-MX',{day:'numeric',month:'short',hour:'2-digit',minute:'2-digit'}):'—'}</td>
                  <td style={{padding:'9px 12px'}}>
                    <div style={{display:'flex',gap:5}}>
                      <button onClick={()=>setActModal(a)} style={{padding:'4px 8px',borderRadius:7,border:'none',background:'rgba(var(--primary-rgb),0.10)',cursor:'pointer',display:'flex'}}><Edit2 size={11} color={DS.primary}/></button>
                      <button onClick={()=>delAction(a.id)} style={{padding:'4px 8px',borderRadius:7,border:'none',background:'#fef2f2',cursor:'pointer',display:'flex'}}><Trash2 size={11} color="#ef4444"/></button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Modal Actividad */}
      {actModal&&(
        <div style={{position:'fixed',inset:0,backdropFilter:'blur(12px)',background:'rgba(var(--primary-rgb),0.3)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
          <div style={{background:'#ffffff',borderRadius:20,padding:26,width:480,boxShadow:'0 20px 60px rgba(0,0,0,0.25)',maxHeight:'90vh',overflowY:'auto'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:16}}>
              <h3 style={{margin:0,fontSize:16,fontWeight:800,color:'var(--dark,#0f172a)'}}>{actModal==='new'?'Nueva actividad':'Editar actividad'}</h3>
              <button onClick={()=>setActModal(null)} style={{border:'none',background:'none',cursor:'pointer'}}><X size={18} color="#94a3b8"/></button>
            </div>
            <ActividadForm act={actModal==='new'?null:actModal} clients={clients} onSave={saveAction} onClose={()=>setActModal(null)}/>
          </div>
        </div>
      )}
    </div>
  );
}


/* ════════════════════════════════════════════
   TAB ACTIVIDADES — historial con edición/borrado, sin espacios muertos
════════════════════════════════════════════ */
function TabActividades({actions,setActions,clients,onCall}){
  const [editModal,setEditModal]=useState(null);
  const [filt,setFilt]=useState('all');
  const ACT_CFG={llamada:{Icon:Phone,c:DS.primary,l:'Llamada'},whatsapp:{Icon:MessageCircle,c:'#25d366',l:'WhatsApp'},mensaje_wa:{Icon:MessageCircle,c:'#25d366',l:'Mensaje WA'},email:{Icon:FileText,c:'#f59e0b',l:'Email'},cita:{Icon:Calendar,c:'#8b5cf6',l:'Cita'},nota:{Icon:FileText,c:'#64748b',l:'Nota'},cambio_estado:{Icon:RefreshCw,c:'#ef4444',l:'Cambio de estado'},venta:{Icon:DollarSign,c:'#10b981',l:'Venta'},reasignacion:{Icon:RefreshCw,c:'#2563eb',l:'Reasignación'}};
  const rows=filt==='all'?actions:actions.filter(a=>a.type===filt);
  const del=id=>askConfirm('Esta actividad será eliminada.', async ()=>{
    try{ await apiFetch('DELETE',`/api/asesor/activities/${id}`); }
    catch(e){ alert(e.message); return; }
    setActions(p=>p.filter(a=>a.id!==id));
  });
  const save=async f=>{
    try{ await apiFetch('PUT',`/api/asesor/activities/${editModal.id}`,{type:f.type,resultado:f.resultado,notas:f.notas}); }
    catch(e){ alert(e.message); }
    setActions(p=>p.map(a=>a.id===editModal.id?{...a,...f}:a));setEditModal(null);
  };
  // Stats
  const calls=actions.filter(a=>a.type==='llamada');
  const avgDur=calls.filter(a=>a.dur).length?Math.round(calls.filter(a=>a.dur).reduce((s,a)=>s+a.dur,0)/calls.filter(a=>a.dur).length):0;

  return(
    <>
      {editModal&&<ActionModal action={editModal} onSave={save} onClose={()=>setEditModal(null)}/>}

      {/* KPIs */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)',gap:12,marginBottom:16}}>
        {[
          {l:'Total actividades', v:actions.length,       c:DS.primary, Ic:Activity},
          {l:'Llamadas',          v:calls.length,          c:'#10b981', Ic:Phone},
          {l:'WhatsApp',          v:actions.filter(a=>a.type==='whatsapp').length, c:'#25d366', Ic:MessageCircle},
          {l:'Prom. duración',    v:fmtT(avgDur),          c:'#f59e0b', Ic:Clock},
        ].map((s,i)=>(
          <div key={i} style={{background:'var(--card-bg,#fff)', borderRadius:16,padding:'14px 16px',border:'1px solid #e5e7eb',display:'flex',gap:10,alignItems:'center'}}>
            <div style={{width:36,height:36,borderRadius:10,background:`${s.c}18`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><s.Ic size={15} color={s.c}/></div>
            <div><div style={{fontSize:20,fontWeight:800,color:'var(--dark,#0f172a)'}}>{s.v}</div><div style={{fontSize:10,color:'#9aa5be'}}>{s.l}</div></div>
          </div>
        ))}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 230px',gap:14}}>
        <div>
          {/* Filtros */}
          <div style={{display:'flex',gap:7,marginBottom:12}}>
            {[{k:'all',l:'Todos'},{k:'llamada',l:'Llamadas', Ic:Phone},{k:'whatsapp',l:'WhatsApp', Ic:MessageCircle},{k:'email',l:'Email',    Ic:FileText},{k:'cita',l:'Citas',    Ic:Calendar}].map(f=>(
              <button key={f.k} onClick={()=>setFilt(f.k)} style={{padding:'6px 12px',borderRadius:8,border:'none',fontSize:11,fontWeight:700,cursor:'pointer',background:filt===f.k?NAVY:'#fff',color:filt===f.k?'#fff':'#475569',boxShadow:'inset 0 0 0 1px #e5e7eb'}}>{f.l}</button>
            ))}
          </div>

          {/* Lista con editar/borrar */}
          <div style={{background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',overflow:'hidden'}}>
            {rows.length===0&&<div style={{padding:28,textAlign:'center',color:'#9aa5be',fontSize:12}}>Sin actividades registradas</div>}
            {rows.map((a,i)=>{
              const cfg=ACT_CFG[a.type]||{Icon:Activity,c:'#94a3b8',l:a.type};
              return(
                <div key={a.id} style={{display:'flex',gap:12,padding:'12px 16px',borderBottom:'1px solid #e2e8f0',alignItems:'flex-start'}}>
                  <div style={{width:36,height:36,borderRadius:9,background:`${cfg.c}15`,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><cfg.Icon size={15} color={cfg.c}/></div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:'flex',gap:8,alignItems:'center',marginBottom:3}}>
                      <span style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{a.cname}</span>
                      <Bdg l={cfg.l} c={cfg.c} b={`${cfg.c}18`}/>
                      {a.dur!=null&&<span style={{fontSize:10,color:cfg.c,fontWeight:700}}>{fmtT(a.dur)}</span>}
                    </div>
                    {a.resultado&&<div style={{fontSize:12,color:'#4a5568',marginBottom:2}}> {a.resultado}</div>}
                    {a.notas&&<div style={{fontSize:11,color:'#9aa5be',fontStyle:'italic'}}>{a.notas}</div>}
                    <div style={{fontSize:10,color:'#cbd5e1',marginTop:3}}>{ago(a.at)}</div>
                  </div>
                  <div style={{display:'flex',gap:5,flexShrink:0}}>
                    <IBtn onClick={()=>setEditModal(a)} bg="#eef2ff" title="Editar"><Edit2 size={11} color={DS.primary}/></IBtn>
                    <IBtn onClick={()=>del(a.id)} bg="#fef2f2" title="Eliminar"><Trash2 size={11} color="#ef4444"/></IBtn>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Sidebar */}
        <div style={{display:'flex',flexDirection:'column',gap:12}}>
          {/* Por tipo */}
          <Panel title="Por tipo" Icon={TrendingUp} color="#8b5cf6">
            {Object.entries(ACT_CFG).map(([k,v])=>{
              const n=actions.filter(a=>a.type===k).length; const mx=Math.max(...Object.values(ACT_CFG).map((_,i,arr)=>actions.filter(a=>a.type===Object.keys(ACT_CFG)[i]).length))||1;
              return(
                <div key={k} style={{marginBottom:9}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:3,fontSize:11}}>
                    <span style={{fontWeight:600,color:'#4a5568',display:'flex',alignItems:'center',gap:4}}><v.Icon size={10} color={v.c}/>{v.l}</span>
                    <span style={{fontWeight:800,color:v.c}}>{n}</span>
                  </div>
                  <div style={{background:'rgba(var(--primary-rgb),0.10)',borderRadius:999,height:5}}><div style={{width:`${(n/mx)*100}%`,height:'100%',background:v.c,borderRadius:999}}/></div>
                </div>
              );
            })}
          </Panel>

          {/* Acciones rápidas */}
          <Panel title="Acción rápida" Icon={Zap} color="#10b981">
            {clients.filter(c=>!c.result).slice(0,5).map(c=>(
              <div key={c.id} style={{display:'flex',gap:7,padding:'7px 0',borderBottom:'1px solid #e2e8f0',alignItems:'center'}}>
                <div style={{flex:1,fontSize:11,fontWeight:700,color:'var(--dark,#0f172a)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.name.split(' ')[0]}</div>
                <IBtn onClick={()=>onCall(c)}><Phone size={10} color={DS.primary}/></IBtn>
                <IBtn onClick={()=>askWhatsApp(c.phone, `Hola ${c.name}`)} bg="#f0fdf4"><MessageCircle size={10} color="#25d366"/></IBtn>
              </div>
            ))}
          </Panel>

          {/* Mejor horario */}
          <Panel title="Mejores horarios" Icon={Clock} color="#f59e0b">
            {[{h:'9-11am',pct:82,c:'#10b981'},{h:'12-2pm',pct:55,c:'#f59e0b'},{h:'3-5pm',pct:70,c:DS.primary},{h:'5-7pm',pct:40,c:'#94a3b8'}].map((s,i)=>(
              <div key={i} style={{marginBottom:8}}>
                <div style={{display:'flex',justifyContent:'space-between',fontSize:11,marginBottom:3}}>
                  <span style={{fontWeight:600,color:'#4a5568'}}>{s.h}</span>
                  <span style={{fontWeight:700,color:s.c}}>{s.pct}%</span>
                </div>
                <div style={{background:'rgba(var(--primary-rgb),0.10)',borderRadius:999,height:5}}><div style={{width:`${s.pct}%`,height:'100%',background:s.c,borderRadius:999}}/></div>
              </div>
            ))}
            <div style={{fontSize:9,color:'#9aa5be',marginTop:4}}>% de llamadas atendidas</div>
          </Panel>
        </div>
      </div>
    </>
  );
}

/* ════════════════════════════════════════════
   TAB MENSAJES — solo supervisor
════════════════════════════════════════════ */
function TabMensajes({ contacts }){
  const [msgs,     setMsgs]    = useState([]);
  const [activeTo, setActiveTo]= useState(null);
  const [texto,    setTexto]   = useState('');
  const [loading,  setLoading] = useState(true);
  const endRef = useRef(null);

  // Separar admin (solo lectura) y supervisores (puede escribir)
  const supervisores = (contacts||[]).filter(c=>c.role==='supervisor');
  const admins       = (contacts||[]).filter(c=>c.role==='admin');
  const contactoActivo = (contacts||[]).find(c=>c.id===activeTo);
  const esAdmin = contactoActivo?.role==='admin';

  useEffect(()=>{
    // Seleccionar primer supervisor por defecto
    if(supervisores.length>0 && !activeTo) setActiveTo(supervisores[0].id);
    else if(contacts?.length>0 && !activeTo) setActiveTo(contacts[0].id);
  },[contacts?.length, activeTo]);

  useEffect(()=>{
    setLoading(true);
    apiFetch('GET','/api/asesor/messages')
      .then(r=>setMsgs(Array.isArray(r)?r:[]))
      .catch(()=>setMsgs([]))
      .finally(()=>setLoading(false));
  },[]);

  useEffect(()=>{ endRef.current?.scrollIntoView({behavior:'smooth'}); },[msgs,activeTo]);

  async function enviar(){
    if(!texto.trim()||!activeTo||esAdmin) return;
    try {
      const r = await apiFetch('POST','/api/asesor/messages',{ toId:activeTo, texto:texto.trim() });
      setMsgs(p=>[...p,r]);
      setTexto('');
    } catch(e){ alert(e.message); }
  }

  const conv = msgs.filter(m=>m.from_id===activeTo||m.to_id===activeTo).sort((a,b)=>new Date(a.created_at)-new Date(b.created_at));
  return(
    <div style={{display:'grid',gridTemplateColumns:'220px 1fr',gap:0,background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb',boxShadow:'0 1px 3px rgba(0,0,0,0.06),0 4px 16px rgba(0,0,0,0.03)',overflow:'hidden',minHeight:500}}>
      {/* Lista contactos */}
      <div style={{borderRight:'1px solid rgba(var(--primary-rgb),0.08)',background:'#f5f7fb',overflowY:'auto'}}>
        <div style={{padding:'12px 14px',borderBottom:'1px solid #e2e8f0',fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>Mensajería interna</div>
        {/* Supervisores - puede escribir */}
        {supervisores.length>0&&<div style={{padding:'5px 12px 3px',fontSize:9,color:'#9aa5be',fontWeight:800,textTransform:'uppercase'}}>Mis supervisores</div>}
        {supervisores.map(c=>{
          const unread=msgs.filter(m=>m.from_id===c.id&&!m.leido).length;
          const last=[...msgs].filter(m=>m.from_id===c.id||m.to_id===c.id).sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
          return(
            <div key={c.id} onClick={()=>setActiveTo(c.id)} style={{padding:'10px 14px',display:'flex',gap:8,alignItems:'center',cursor:'pointer',background:activeTo===c.id?'#f5f3ff':'transparent',borderBottom:'1px solid #e2e8f0'}}>
              <div style={{width:34,height:34,borderRadius:'50%',background:'#f5f3ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#8b5cf6',flexShrink:0}}>{(c.name||'?').charAt(0)}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{c.name}</div>
                <div style={{fontSize:10,color:'#8b5cf6',fontWeight:600}}> Supervisor</div>
                {last&&<div style={{fontSize:9,color:'#9aa5be',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{last.texto}</div>}
              </div>
              {unread>0&&<div style={{width:17,height:17,borderRadius:'50%',background:'#8b5cf6',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:800,color:'#fff'}}>{unread}</div>}
            </div>
          );
        })}
        {/* Admin - solo lectura */}
        {admins.length>0&&<div style={{padding:'8px 12px 3px',fontSize:9,color:'#9aa5be',fontWeight:800,textTransform:'uppercase'}}>Administrador</div>}
        {admins.map(c=>{
          const unread=msgs.filter(m=>m.from_id===c.id&&!m.leido).length;
          const last=[...msgs].filter(m=>m.from_id===c.id||m.to_id===c.id).sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
          return(
            <div key={c.id} onClick={()=>setActiveTo(c.id)} style={{padding:'10px 14px',display:'flex',gap:8,alignItems:'center',cursor:'pointer',background:activeTo===c.id?'#fef3c7':'transparent',borderBottom:'1px solid #e2e8f0'}}>
              <div style={{width:34,height:34,borderRadius:'50%',background:'#fef3c7',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:'#d97706',flexShrink:0}}>{(c.name||'?').charAt(0)}</div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{c.name}</div>
                <div style={{fontSize:10,color:'#d97706',fontWeight:600}}> Admin — Solo lectura</div>
                {last&&<div style={{fontSize:9,color:'#9aa5be',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{last.texto}</div>}
              </div>
              {unread>0&&<div style={{width:17,height:17,borderRadius:'50%',background:'#f59e0b',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,fontWeight:800,color:'#fff'}}>{unread}</div>}
            </div>
          );
        })}
        {(!contacts||contacts.length===0)&&<div style={{padding:16,fontSize:11,color:'#9aa5be',textAlign:'center'}}>Sin contactos disponibles</div>}
      </div>

      {/* Chat */}
      <div style={{display:'flex',flexDirection:'column'}}>
        {contactoActivo?(
          <div style={{padding:'11px 16px',borderBottom:'1px solid #e2e8f0',display:'flex',alignItems:'center',gap:9,background:'#f5f7fb'}}>
            <div style={{width:34,height:34,borderRadius:'50%',background:contactoActivo.role==='admin'?'#fef3c7':'#f5f3ff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,fontWeight:800,color:contactoActivo.role==='admin'?'#d97706':'#8b5cf6'}}>{(contactoActivo.name||'?').charAt(0)}</div>
            <div><div style={{fontSize:13,fontWeight:700,color:'var(--dark,#0f172a)'}}>{contactoActivo.name}</div><div style={{fontSize:10,color:'#9aa5be'}}>{contactoActivo.role==='admin'?'Administrador':'Supervisor'}</div></div>
          </div>
        ):(
          <div style={{padding:'11px 16px',borderBottom:'1px solid #e2e8f0',background:'#f5f7fb',color:'#9aa5be',fontSize:12}}>Selecciona un contacto</div>
        )}
        <div style={{flex:1,overflowY:'auto',padding:'14px 16px',display:'flex',flexDirection:'column',gap:9,minHeight:280}}>
          {loading&&<div style={{color:'#9aa5be',fontSize:12,textAlign:'center',marginTop:40}}>Cargando...</div>}
          {!loading&&conv.length===0&&<div style={{color:'#9aa5be',fontSize:12,textAlign:'center',marginTop:40}}>Sin mensajes aún. ¡Escribe algo!</div>}
          {conv.map(m=>{
            const mine=m.from_role==='asesor'||m.from_role==='advisor';
            return(
              <div key={m.id} style={{display:'flex',justifyContent:mine?'flex-end':'flex-start'}}>
                <div style={{maxWidth:'70%',padding:'9px 13px',borderRadius:mine?'14px 14px 4px 14px':'14px 14px 14px 4px',background:mine?DS.primary:'#f1f5f9',color:mine?'#fff':'#374151',fontSize:13,lineHeight:1.5}}>
                  {!mine&&<div style={{fontSize:10,fontWeight:700,color:DS.primary,marginBottom:2}}>{m.from_name}</div>}
                  {m.texto}
                  <div style={{fontSize:9,marginTop:3,opacity:.65,textAlign:'right'}}>{new Date(m.created_at).toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'})}</div>
                </div>
              </div>
            );
          })}
          <div ref={endRef}/>
        </div>
        {esAdmin ? (
          <div style={{padding:'12px 16px',borderTop:'1px solid #e2e8f0',background:'#fef3c7',display:'flex',alignItems:'center',gap:8}}>
            <span style={{fontSize:11,color:'#92400e'}}>️ Solo puedes ver los mensajes del administrador, no responder.</span>
          </div>
        ) : (
          <div style={{padding:'9px 14px',borderTop:'1px solid #e2e8f0',display:'flex',gap:9,alignItems:'flex-end'}}>
            <textarea value={texto} onChange={e=>setTexto(e.target.value)}
              onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();enviar();}}}
              placeholder={contactoActivo?`Escribe a ${contactoActivo.name.split(' ')[0]}... (Enter para enviar)`:'Selecciona contacto'} rows={2} disabled={!activeTo}
              style={{flex:1,padding:'8px 12px',border:'1px solid #cbd5e1',borderRadius:10,fontSize:12,resize:'none',outline:'none'}}/>
            <button onClick={enviar} disabled={!texto.trim()||!activeTo} style={{padding:'11px 14px',borderRadius:10,border:'none',background:!texto.trim()||!activeTo?'#f1f5f9':DS.primary,color:!texto.trim()||!activeTo?'#94a3b8':'#fff',cursor:'pointer',display:'flex',alignItems:'center',gap:5,fontWeight:700,fontSize:12}}>
              <Send size={13}/> Enviar
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════
   TAB LEADS — KANBAN con drag & drop
════════════════════════════════════════════ */

// ══════════════════════════════════════════════════════════
// TAB: CONVERSACIONES DEL BOT (lo que Claudia habló con el cliente)
// ══════════════════════════════════════════════════════════
// ── Tabla de cotizaciones Busimott (replicada del backend) ───────────────────
const TABLA_COT = {
  6000:  {36:195.37,42:167.46,48:146.53,54:130.24,60:117.22,66:106.56,72:97.68,  ins:336, tp:433.68 },
  7000:  {36:227.93,42:195.37,48:170.95,54:151.95,60:136.76,66:124.32,72:113.96, ins:392, tp:505.96 },
  8000:  {36:260.49,42:223.28,48:195.37,54:173.66,60:156.29,66:142.08,72:130.24, ins:448, tp:578.24 },
  9000:  {36:293.05,42:251.19,48:219.79,54:195.37,60:175.83,66:159.85,72:146.53, ins:504, tp:650.53 },
  10000: {36:325.61,42:279.10,48:244.21,54:217.07,60:195.37,66:177.61,72:162.81, ins:560, tp:722.81 },
  11000: {36:358.17,42:307.00,48:268.63,54:238.78,60:214.90,66:195.37,72:179.09, ins:616, tp:795.09 },
  12000: {36:390.73,42:334.91,48:293.05,54:260.49,60:234.44,66:213.13,72:195.37, ins:672, tp:867.37 },
  13000: {36:423.29,42:362.82,48:317.47,54:282.20,60:253.98,66:230.89,72:211.65, ins:728, tp:939.65 },
  14000: {36:455.86,42:390.73,48:341.89,54:303.90,60:273.51,66:248.65,72:227.93, ins:784, tp:1011.93},
  15000: {36:488.42,42:418.64,48:366.31,54:325.61,60:293.05,66:266.41,72:244.21, ins:840, tp:1084.21},
  16000: {36:520.98,42:446.55,48:390.73,54:347.32,60:312.59,66:284.17,72:260.49, ins:896, tp:1156.49},
  17000: {36:553.54,42:474.46,48:415.15,54:369.03,60:332.12,66:301.93,72:276.77, ins:952, tp:1228.77},
  18000: {36:586.10,42:502.37,48:439.58,54:390.73,60:351.66,66:319.69,72:293.05, ins:1008,tp:1301.05},
  19000: {36:618.66,42:530.28,48:464.00,54:412.44,60:371.20,66:337.45,72:309.33, ins:1064,tp:1373.33},
  20000: {36:651.22,42:558.19,48:488.42,54:434.15,60:390.73,66:355.21,72:325.61, ins:1120,tp:1445.61},
};
function getCotRow(valor) {
  const v = Math.max(6000,Math.min(20000,Math.round(Number(valor)/1000)*1000));
  return { row: TABLA_COT[v], base: v };
}
function generarCotFrontend(valor, modalidad, plazo) {
  const { row, base } = getCotRow(valor);
  if (!row) return '';
  const vl    = `${base/1000}mil`;
  const cuota = (row[plazo] ?? row[72]).toFixed(2);
  const tp    = row.tp.toFixed(2);
  const e70   = Math.round(base*0.70);
  const mega  = `🟡 Modalidad Mega Estrella (valor ${vl})\n\n📑 Invierte el 70%= $${e70}\n\nDisfrute su vehículo en apenas 20 días hábiles 🚘\n\n🔸 Valor restante diferido:\n12 meses\n18 meses`;
  const super_ = `🟡 Modalidad Súper Estrella (valor ${vl})\n\n✅ Activación de servicio (beneficios)= $${tp} su primera mensualidad ya está incluida.📑\n\nMensualidades económicas de $${cuota}\nAl 4to mes cancela el 35% de entrada.`;
  const estr  = `🟡 Modalidad Estrella (valor ${vl})\n\n✅ Activación de servicio (beneficios)= $${tp} su primera mensualidad ya está incluida.📑\n\nMensualidades económicas de $${cuota}\n\n🚘 Prepárese para recibir su vehículo desde el séptimo mes`;
  if (modalidad === 'mega_estrella')  return mega;
  if (modalidad === 'super_estrella') return super_;
  if (modalidad === 'estrella')       return estr;
  return `${mega}\n\n${super_}\n\n${estr}`;
}

const MSGS_RAPIDOS = [
  { id:'cotizacion', Icon:TrendingUp,  label:'Cotización',     desc:'Genera cotización editable',        special:true  },
  { id:'modalidades',Icon:Star,        label:'Modalidades',    desc:'Las 3 formas de pago',
    texto:`Así funciona cada modalidad:\n⭐ Mega Estrella:  Entrada del 70% para acceder a beneficios preferenciales.\n⭐ Súper Estrella: Empieza hoy y pague una entrada mínima del 35% en el 4to mes.\n⭐ Estrella: Accede a tu vehículo con pagos flexibles.\n\n¿Indíqueme con qué modalidad de pago adquiere su vehículo?` },
  { id:'beneficios', Icon:Gift,        label:'Beneficios',     desc:'Ventajas de adquirir con Busimott',
    texto:`🎁 *Beneficios de adquirir su vehículo con Busimott:*\n\n✅ Vehículo 0 km totalmente a su nombre\n✅ Sin garante y sin necesidad de historial crediticio\n✅ Mensualidades fijas y económicas\n✅ Acompañamiento personalizado durante todo el proceso\n✅ Entrega ágil según la modalidad que elija\n\n¿Le gustaría que le indique con cuál modalidad puede empezar hoy mismo? 🚗` },
  { id:'requisitos', Icon:FileText,    label:'Requisitos',     desc:'Documentos que necesita el cliente',
    texto:`📋 *Requisitos para iniciar:*\n❇️ Cédula de identidad y papeleta de votación\n❇️ Correo electrónico vigente\n❇️ Valor de activación según el plan elegido` },
  { id:'cuenta',     Icon:CreditCard,  label:'Cuenta de pago', desc:'Datos para transferencia bancaria',
    texto:`💳 *Cuenta para registrar su pago:*\n\n👤 Titular: Business Motors Busimott. Cía. Ltda.\n🏦 Banco: Banco del Pichincha\n📋 Tipo: Cuenta Corriente\n🔢 N° de cuenta: 2100247020\n🆔 RUC: 1793140491001\n\n⚠️ Una vez realizado el pago, envíenos el comprobante por este chat.\nAl confirmar el pago procedemos con el envío de su contrato. 🚗` },
  { id:'direccion',  Icon:MapPin,      label:'Dirección',      desc:'Ubicación de las oficinas',
    texto:`📍 *Oficinas Busimott Cía. Ltda.*\n\n🏢 Av. Eloy Alfaro E7-103 y De Los Eucaliptos, Quito\n📞 023 50 0328\n✉️ bussimott.info@gmail.com\n\n¿Qué día y hora le viene mejor para visitarnos? 🤝` },
  { id:'catalogo',   Icon:Image,       label:'Catálogo',       desc:'Link de modelos disponibles',
    texto:`Con gusto 📸 Aquí puede ver todos nuestros modelos disponibles:\n\nhttps://ibb.co/album/PMkJhp\n\nUna vez elija el modelo que le guste, indíqueme el valor del vehículo o el abono mensual que le acomoda y le genero la cotización de inmediato. ¿Cuál le llama la atención?` },
  { id:'valor',      Icon:DollarSign,  label:'Consultar valor', desc:'Preguntar el valor del vehículo',
    texto:`🚗 Para generarle una cotización exacta, cuénteme:\n\n💰 ¿Qué valor de vehículo tiene en mente?\n(Nuestros planes van desde $6.000 hasta $20.000)\n\nO si prefiere, indíqueme la cuota mensual que se ajusta a su presupuesto y yo le calculo el valor ideal para usted. 😊` },
  { id:'servicio',   Icon:Phone,       label:'Servicio al cliente', desc:'Número de servicio al cliente',
    texto:`📞 Para mayor información sobre tu requerimiento, comunícate al siguiente número de servicio al cliente:\n\n0999097014` },
];

function TabBotConversaciones({ leads, initial }) {
  const p = DS.primary;
  const [selectedLead, setSelectedLead] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate]     = useState('');
  const [msgText, setMsgText]       = useState('');
  const [quickOpen, setQuickOpen]   = useState(false);
  const [cotOpen, setCotOpen]       = useState(false);
  const [cotValor, setCotValor]     = useState(9000);
  const [cotModal, setCotModal]     = useState('todas');
  const [cotPlazo, setCotPlazo]     = useState(72);
  const inputRef = useRef(null);
  const endRef = useRef(null);
  const inp = { width: '100%', padding: '8px 12px', borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, outline: 'none', boxSizing: 'border-box', background: '#f8fafc' };

  // Auto-scroll al último mensaje: así no hay que arrastrar la barra para ver lo más reciente.
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [conversations, selectedLead]);

  async function loadConversations(lead) {
    setLoading(true);
    try {
      const data = await apiFetch('GET', `/api/webhook/conversations/${lead.id}`);
      setConversations(Array.isArray(data) ? data : []);
    } catch(e) {
      setConversations([]);
    }
    setLoading(false);
  }

  function selectLead(lead) {
    setSelectedLead(lead);
    setMsgText('');
    setQuickOpen(false);
    setCotOpen(false);
    apiFetch('POST', `/api/supervisor/leads/${lead.id}/contactar`, {}).catch(()=>{});
    loadConversations(lead);
  }

  // Al llegar desde "Ver conversación" de un cliente, abrir su conversación
  useEffect(() => {
    if (initial && initial.id) selectLead(initial);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initial]);

  function handleMsgChange(e) {
    const val = e.target.value;
    setMsgText(val);
    if (val === '*') { setQuickOpen(true); setCotOpen(false); }
    else if (!val.startsWith('*')) { setQuickOpen(false); setCotOpen(false); }
  }

  function insertarMensaje(texto) {
    setMsgText(texto);
    setQuickOpen(false);
    setCotOpen(false);
    setTimeout(() => inputRef.current?.focus(), 50);
  }

  function seleccionarOpcion(item) {
    if (item.special) { setCotOpen(true); return; }
    insertarMensaje(item.texto);
  }

  async function enviarMensaje() {
    const txt = msgText.trim();
    if (!txt || !selectedLead) return;
    try {
      let sendPhone = (selectedLead.telefono||'').replace(/\D/g,'');
      if (sendPhone.startsWith('0') && sendPhone.length===10) sendPhone='593'+sendPhone.substring(1);
      else if (sendPhone.length===9) sendPhone='593'+sendPhone;
      await apiFetch('POST', '/api/messages/send', {
        leadId:    selectedLead.id,
        phone:     sendPhone,
        message:   txt,
        companyId: selectedLead.company_id,
      });
      setMsgText('');
      setQuickOpen(false);
      setCotOpen(false);
      loadConversations(selectedLead);
    } catch(e) { alert('Error al enviar: ' + e.message); }
  }

  const filteredLeads = leads.filter(l => {
    const matchTxt = l.nombre?.toLowerCase().includes(search.toLowerCase()) || l.telefono?.includes(search);
    if (!matchTxt) return false;
    const fecha = (l.created_at || l.fecha || '').slice(0,10);
    if (fromDate && fecha < fromDate) return false;
    if (toDate   && fecha > toDate)   return false;
    return true;
  });

  const NIVEL = {
    caliente: { c: '#10b981', bg: '#f0fdf9', label: 'Caliente' },
    tibio:    { c: '#f59e0b', bg: '#fefce8', label: 'Tibio'    },
    frio:     { c: '#ef4444', bg: '#fef2f2', label: 'Frío'     },
  };
  // Paginado: con cientos de leads, renderizarlos todos de una vez es lo que traba el clic en la pestaña.
  const { paged: pagedLeads, ...pgLeads } = usePaged(filteredLeads, 30);

  return (
    <div style={{ display: MOB ? 'block' : 'grid', gridTemplateColumns: '320px 1fr', gap: 16, height: MOB ? 'auto' : '75vh', background: 'transparent' }}>

      {/* LISTA DE LEADS — en móvil se oculta cuando hay lead seleccionado */}
      {(!MOB || !selectedLead) && (
      <div style={{ background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', display: 'flex', flexDirection: 'column', overflow: 'hidden', height: MOB ? '70vh' : 'auto' }}>
        <div style={{ padding: '14px 16px', borderBottom: '1px solid #eaecf0' }}>
          <div style={{ fontSize: 11, color: p, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 8 }}>Leads del Bot</div>
          <input style={{...inp, marginBottom:6}} placeholder="Buscar por nombre o teléfono..." value={search} onChange={e => setSearch(e.target.value)} />
          <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <input type="date" value={fromDate} max={toDate||undefined} onChange={e=>setFromDate(e.target.value)}
              style={{ flex:1, padding:'6px 8px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:11, fontWeight:700, color:'#475569', outline:'none', cursor:'pointer' }}/>
            <span style={{ fontSize:10, color:'#94a3b8', fontWeight:700 }}>a</span>
            <input type="date" value={toDate} min={fromDate||undefined} onChange={e=>setToDate(e.target.value)}
              style={{ flex:1, padding:'6px 8px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:11, fontWeight:700, color:'#475569', outline:'none', cursor:'pointer' }}/>
            {(fromDate||toDate) && <button onClick={()=>{setFromDate('');setToDate('');}} title="Limpiar fechas" style={{ background:'none', border:'none', cursor:'pointer', color:'#94a3b8', padding:2 }}><X size={13}/></button>}
          </div>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {filteredLeads.length === 0 && (
            <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>No hay leads del bot aún</div>
          )}
          {pagedLeads.map(lead => {
            const nv = NIVEL[lead.nivel] || NIVEL.frio;
            const isSelected = selectedLead?.id === lead.id;
            return (
              <div key={lead.id} onClick={() => selectLead(lead)}
                style={{ padding: '12px 16px', borderBottom: '1px solid #f1f5f9', cursor: 'pointer', background: isSelected ? `${p}08` : 'transparent', borderLeft: isSelected ? `3px solid ${p}` : '3px solid transparent', transition: 'all .15s' }}
                onMouseEnter={e => { if (!isSelected) e.currentTarget.style.background = '#f8fafc'; }}
                onMouseLeave={e => { if (!isSelected) e.currentTarget.style.background = 'transparent'; }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 4, gap: 6 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--dark,#0f172a)' }}>{lead.nombre}</span>
                  <div style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                    {lead.metadata?.asesor_contacto
                      ? <span style={{ fontSize: 9, fontWeight: 700, color: '#059669', background: '#f0fdf4', padding: '2px 8px', borderRadius: 999, whiteSpace: 'nowrap' }}>✓ Contactado</span>
                      : <span style={{ fontSize: 9, fontWeight: 700, color: '#94a3b8', background: '#f1f5f9', padding: '2px 8px', borderRadius: 999, whiteSpace: 'nowrap' }}>Sin contactar</span>}
                    <span style={{ fontSize: 10, fontWeight: 700, color: nv.c, background: nv.bg, padding: '2px 8px', borderRadius: 999 }}>{nv.label}</span>
                  </div>
                </div>
                <div style={{ fontSize: 11, color: '#64748b' }}>{lead.telefono}</div>
                {lead.msgBot && (
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4, fontStyle: 'italic', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    "{lead.msgBot}"
                  </div>
                )}
                <div style={{ display: 'flex', gap: 8, marginTop: 6, alignItems: 'center' }}>
                  <div style={{ flex: 1, background: '#e2e8f0', borderRadius: 999, height: 4 }}>
                    <div style={{ width: `${lead.score || 0}%`, height: '100%', background: nv.c, borderRadius: 999 }} />
                  </div>
                  <span style={{ fontSize: 10, color: '#94a3b8', minWidth: 32 }}>Score: {lead.score || 0}</span>
                </div>
              </div>
            );
          })}
          <Pagination {...pgLeads} primary={p} label="leads" />
        </div>
      </div>
      )}

      {/* CONVERSACIÓN — en móvil solo se muestra cuando hay lead seleccionado */}
      {(!MOB || selectedLead) && (
      <div style={{ background:'var(--card-bg,#fff)',borderRadius:16,border:'1px solid #e5e7eb', display: 'flex', flexDirection: 'column', overflow: 'hidden', height: MOB ? '70vh' : 'auto', marginTop: MOB ? 0 : 0 }}>
        {!selectedLead ? (
          <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
            <MessageCircle size={40} color="#e2e8f0" />
            <div style={{ fontSize: 14, color: '#94a3b8', fontWeight: 600 }}>Selecciona un lead para ver la conversación</div>
            <div style={{ fontSize: 12, color: '#cbd5e1' }}>Aquí verás todo lo que Claudia habló con el cliente</div>
          </div>
        ) : (
          <>
            {/* Header del chat */}
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #eaecf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                {MOB && (
                  <button onClick={() => setSelectedLead(null)} style={{ flexShrink: 0, padding: '6px 10px', borderRadius: 8, border: `1px solid ${DS.primary}20`, background: `${DS.primary}08`, color: DS.primary, fontWeight: 700, fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 4 }}>
                    ← Volver
                  </button>
                )}
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--dark,#0f172a)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedLead.nombre}</div>
                  <div style={{ fontSize: 11, color: '#64748b' }}>{selectedLead.telefono} · Score: {selectedLead.score}/100</div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => askWhatsApp(selectedLead.telefono, `Hola ${selectedLead.nombre||''}, soy tu asesor de BUSIMOTT`, selectedLead.id)}
                  style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: '#f0fdf9', color: '#059669', fontWeight: 700, fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
                  <MessageCircle size={13} /> Continuar en WhatsApp
                </button>
              </div>
            </div>

            {/* Mensajes */}
            <div style={{ flex: 1, overflowY: 'auto', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: 10, background: '#f8fafc' }}>
              {loading && (
                <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: 20 }}>Cargando conversación...</div>
              )}
              {!loading && conversations.length === 0 && (
                <div style={{ textAlign: 'center', color: '#94a3b8', fontSize: 13, padding: 20 }}>
                  <MessageCircle size={28} color="#e2e8f0" style={{ marginBottom: 8, display: 'block', margin: '0 auto 8px' }} />
                  Sin conversaciones registradas aún
                </div>
              )}
              {conversations.map((msg, i) => {
                const isBot    = msg.direction === 'outbound';
                const isClient = msg.direction === 'inbound';
                return (
                  <div key={i} style={{ display: 'flex', justifyContent: isBot ? 'flex-start' : 'flex-end' }}>
                    <div style={{ maxWidth: '72%' }}>
                      {isBot && (
                        <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 3, marginLeft: 4 }}>Claudia (Bot)</div>
                      )}
                      {isClient && (
                        <div style={{ fontSize: 10, color: '#94a3b8', marginBottom: 3, textAlign: 'right', marginRight: 4 }}>{selectedLead.nombre}</div>
                      )}
                      <div style={{
                        padding: '10px 14px',
                        borderRadius: isBot ? '4px 14px 14px 14px' : '14px 4px 14px 14px',
                        background: isBot ? '#fff' : p,
                        color: isBot ? 'var(--dark,#0f172a)' : '#fff',
                        fontSize: 13,
                        lineHeight: 1.5,
                        border: isBot ? '1px solid #e2e8f0' : 'none',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                      }}>
                        {msg.message_text&&msg.message_text.startsWith('[IMG:')?(()=>{const u=msg.message_text.match(/\[IMG:(.*?)\]/);return u?(<><img src={(process.env.REACT_APP_API_URL||'')+u[1]} alt="Imagen" style={{maxWidth:'100%',borderRadius:8,marginBottom:4,cursor:'pointer'}} onClick={()=>window.open((process.env.REACT_APP_API_URL||'')+u[1],'_blank')}/><div style={{fontSize:11}}>{msg.message_text.replace(/\[IMG:.*?\]\s*/,'')}</div></>):msg.message_text;})():msg.message_text}
                      </div>
                      <div style={{ fontSize: 10, color: '#cbd5e1', marginTop: 3, textAlign: isBot ? 'left' : 'right', marginLeft: isBot ? 4 : 0, marginRight: isClient ? 4 : 0 }}>
                        {msg.created_at ? new Date(msg.created_at).toLocaleString('es-EC', { month:'short', day:'numeric', hour:'2-digit', minute:'2-digit' }) : ''}
                        {msg.intent && isBot && <span style={{ marginLeft: 6, color: '#a78bfa' }}>· {msg.intent}</span>}
                      </div>
                    </div>
                  </div>
                );
              })}
              <div ref={endRef}/>
            </div>

            {/* Footer — mensajes rápidos + textarea */}
            <div style={{ padding: '10px 16px 12px', borderTop: '1px solid #eaecf0', background: '#fff', position: 'relative' }}>

              {/* ── Panel mensajes rápidos ──────────────────────────────── */}
              {quickOpen && (
                <div style={{ position:'absolute', bottom:'100%', left:16, right:16, marginBottom:6, background:'#fff', border:'1.5px solid #e2e8f0', borderRadius:14, boxShadow:'0 8px 32px rgba(0,0,0,0.13)', zIndex:100, overflow:'hidden' }}>
                  {/* Header */}
                  <div style={{ padding:'10px 14px 8px', borderBottom:'1px solid #f1f5f9', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                    <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                      <Zap size={14} color={p} />
                      <span style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)' }}>Mensajes Rápidos</span>
                    </div>
                    <button onClick={()=>{setQuickOpen(false);setCotOpen(false);setMsgText('');}} style={{ background:'none',border:'none',cursor:'pointer',color:'#94a3b8',padding:2 }}><X size={15}/></button>
                  </div>

                  {/* Opciones en grid */}
                  {!cotOpen && (
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:0 }}>
                      {MSGS_RAPIDOS.map((item,i) => (
                        <button key={item.id} onClick={()=>seleccionarOpcion(item)}
                          style={{ padding:'12px 10px', background:'transparent', border:'none', borderRight: i%3!==2?'1px solid #f1f5f9':'none', borderBottom:'1px solid #f1f5f9', cursor:'pointer', textAlign:'left', transition:'background .12s' }}
                          onMouseEnter={e=>e.currentTarget.style.background='#f8fafc'}
                          onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                          <div style={{ marginBottom:6, display:'flex', alignItems:'center', justifyContent:'flex-start' }}>
                            <div style={{ width:32, height:32, borderRadius:8, background:`${p}14`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                              <item.Icon size={16} color={p} />
                            </div>
                          </div>
                          <div style={{ fontSize:12, fontWeight:700, color:'var(--dark,#0f172a)', marginBottom:2 }}>{item.label}</div>
                          <div style={{ fontSize:10, color:'#94a3b8', lineHeight:1.3 }}>{item.desc}</div>
                        </button>
                      ))}
                    </div>
                  )}

                  {/* Sub-panel cotizador */}
                  {cotOpen && (
                    <div style={{ padding:'14px 16px' }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
                        <button onClick={()=>setCotOpen(false)} style={{ background:'none',border:'none',cursor:'pointer',color:'#64748b',padding:0,display:'flex',alignItems:'center' }}><ChevronLeft size={16}/></button>
                        <span style={{ fontSize:13, fontWeight:700, color:'var(--dark,#0f172a)' }}>📊 Generador de Cotización</span>
                      </div>

                      {/* Controles */}
                      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:12 }}>
                        <div>
                          <label style={{ fontSize:10, fontWeight:700, color:'#64748b', display:'block', marginBottom:4 }}>VALOR DEL VEHÍCULO</label>
                          <select value={cotValor} onChange={e=>setCotValor(Number(e.target.value))}
                            style={{ width:'100%', padding:'7px 10px', borderRadius:8, border:'1.5px solid #e2e8f0', fontSize:13, outline:'none', background:'#fff' }}>
                            {Object.keys(TABLA_COT).map(v=>(
                              <option key={v} value={v}>${Number(v).toLocaleString()}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <label style={{ fontSize:10, fontWeight:700, color:'#64748b', display:'block', marginBottom:4 }}>MODALIDAD</label>
                          <select value={cotModal} onChange={e=>setCotModal(e.target.value)}
                            style={{ width:'100%', padding:'7px 10px', borderRadius:8, border:'1.5px solid #e2e8f0', fontSize:13, outline:'none', background:'#fff' }}>
                            <option value="todas">Todas las modalidades</option>
                            <option value="mega_estrella">Mega Estrella ⭐⭐⭐</option>
                            <option value="super_estrella">Súper Estrella ⭐⭐</option>
                            <option value="estrella">Estrella ⭐</option>
                          </select>
                        </div>
                        <div>
                          <label style={{ fontSize:10, fontWeight:700, color:'#64748b', display:'block', marginBottom:4 }}>PLAZO (MESES)</label>
                          <select value={cotPlazo} onChange={e=>setCotPlazo(Number(e.target.value))}
                            style={{ width:'100%', padding:'7px 10px', borderRadius:8, border:'1.5px solid #e2e8f0', fontSize:13, outline:'none', background:'#fff' }}>
                            {[36,42,48,54,60,66,72].map(pl=>(
                              <option key={pl} value={pl}>{pl} meses{pl===72?' (+ económico)':''}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Preview */}
                      <div style={{ background:'#f8fafc', borderRadius:10, padding:'10px 12px', marginBottom:10, maxHeight:130, overflowY:'auto', border:'1px solid #e2e8f0' }}>
                        <pre style={{ margin:0, fontSize:11, color:'var(--dark,#0f172a)', whiteSpace:'pre-wrap', fontFamily:'inherit', lineHeight:1.5 }}>
                          {generarCotFrontend(cotValor, cotModal, cotPlazo)}
                        </pre>
                      </div>

                      {/* Botón insertar */}
                      <button onClick={()=>insertarMensaje(generarCotFrontend(cotValor, cotModal, cotPlazo))}
                        style={{ width:'100%', padding:'9px', borderRadius:9, border:'none', background:p, color:'#fff', fontWeight:700, fontSize:13, cursor:'pointer' }}>
                        Insertar en el chat
                      </button>
                    </div>
                  )}

                  {/* Hint */}
                  {!cotOpen && (
                    <div style={{ padding:'6px 14px', fontSize:10, color:'#cbd5e1', textAlign:'center', borderTop:'1px solid #f1f5f9' }}>
                      Selecciona una opción · ESC para cerrar
                    </div>
                  )}
                </div>
              )}

              {/* ── Input + botones ─────────────────────────────────────── */}
              {(()=>{
                const lastIn = [...conversations].filter(m=>m.direction==='inbound').sort((a,b)=>new Date(b.created_at)-new Date(a.created_at))[0];
                const horas  = lastIn ? (Date.now()-new Date(lastIn.created_at).getTime())/(1000*60*60) : 999;
                const cerrada = horas > 24;
                if (cerrada) return (
                  <div style={{ background:'#fef3c7', border:'1px solid #fde68a', borderRadius:10, padding:'14px 16px', display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
                    <Clock size={18} color='#d97706'/>
                    <div>
                      <div style={{ fontSize:13, fontWeight:700, color:'#92400e' }}>Ventana de 24 horas cerrada</div>
                      <div style={{ fontSize:11, color:'#b45309', marginTop:2 }}>Espera a que el cliente te escriba de nuevo para poder responder.</div>
                    </div>
                    <button onClick={()=>askWhatsApp(selectedLead.telefono)}
                      style={{ marginLeft:'auto', padding:'7px 12px', borderRadius:8, border:'none', background:'#25d366', color:'#fff', fontWeight:700, fontSize:11, cursor:'pointer', display:'flex', alignItems:'center', gap:4, whiteSpace:'nowrap', flexShrink:0 }}>
                      <MessageCircle size={11}/> Abrir WA
                    </button>
                  </div>
                );
                return (<>
                  <div style={{ display:'flex', gap:8, alignItems:'flex-end', marginBottom:6 }}>
                    <div style={{ flex:1, position:'relative' }}>
                      <textarea
                        ref={inputRef}
                        value={msgText}
                        onChange={handleMsgChange}
                        rows={2}
                        placeholder="Escribe un mensaje… o escribe * para mensajes rápidos"
                        style={{ width:'100%', padding:'10px 14px', borderRadius:10, border: quickOpen?`1.5px solid ${p}`:'1px solid #e2e8f0', fontSize:13, resize:'none', outline:'none', fontFamily:'inherit', lineHeight:1.5, boxSizing:'border-box', transition:'border-color .15s' }}
                        onKeyDown={e => {
                          if (e.key==='Escape') { setQuickOpen(false); setCotOpen(false); setMsgText(''); }
                          if (e.key==='Enter'&&!e.shiftKey&&!quickOpen) { e.preventDefault(); enviarMensaje(); }
                        }}
                      />
                      {!quickOpen && (
                        <button onClick={()=>{setMsgText('*');setQuickOpen(true);setCotOpen(false);setTimeout(()=>inputRef.current?.focus(),50);}}
                          title="Mensajes rápidos (*)"
                          style={{ position:'absolute', right:8, bottom:8, background:'none', border:'1px solid #e2e8f0', borderRadius:6, padding:'4px 6px', cursor:'pointer', display:'flex', alignItems:'center' }}>
                          <Zap size={13} color='#94a3b8' />
                        </button>
                      )}
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                      <button onClick={enviarMensaje}
                        style={{ padding:'10px 16px', borderRadius:9, border:'none', background:'#25d366', color:'#fff', fontWeight:700, fontSize:12, cursor:'pointer', display:'flex', alignItems:'center', gap:5, whiteSpace:'nowrap' }}>
                        <Send size={13}/> Enviar
                      </button>
                      <button onClick={()=>askWhatsApp(selectedLead.telefono, `Hola ${selectedLead.nombre||''}, soy tu asesor de BUSIMOTT`, selectedLead.id)}
                        style={{ padding:'8px 16px', borderRadius:9, border:'none', background:'#f0fdf9', color:'#059669', fontWeight:700, fontSize:11, cursor:'pointer', display:'flex', alignItems:'center', gap:5, whiteSpace:'nowrap' }}>
                        <MessageCircle size={11}/> Abrir WA
                      </button>
                    </div>
                  </div>
                  <div style={{ fontSize:10, color:'#94a3b8', textAlign:'center' }}>
                    Escribe <strong>*</strong> para mensajes rápidos · Enter envía · Shift+Enter nueva línea · Score: {selectedLead.score}/100
                  </div>
                </>);
              })()}
            </div>
          </>
        )}
      </div>
      )}
    </div>
  );

}



/* ════════════════════════════════════════════
   TAB DASHBOARD
════════════════════════════════════════════ */



// ── Canal Stats — Estadísticas por red social ─────────────────────────────


function TabEstadisticasPersonales({stats, leads, clients, actions, events, onNavigate}) {
  const p = DS.primary;
  const nav = onNavigate || (()=>{});
  const [hov, setHov] = React.useState(null);

  if (!stats) return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:300}}>
      <div style={{textAlign:'center'}}>
        <div style={{width:48,height:48,borderRadius:'50%',background:`${p}15`,display:'flex',alignItems:'center',justifyContent:'center',margin:'0 auto 12px'}}>
          <Activity size={22} color={p}/>
        </div>
        <div style={{fontSize:14,fontWeight:700,color:'var(--dark,#0f172a)'}}>Cargando estadísticas...</div>
      </div>
    </div>
  );

  const ganados   = stats.clients?.ganados    || 0;
  const meta      = stats.meta_mes            || 10;
  const avance    = stats.avance_meta         || 0;
  const totalLeads = (stats.leads?.total||0) || 1;

  // Cards interactivas con navegacion
  const kpis = [
    { l:'Mis Clientes',      v:stats.clients?.total||0,        c:DS.primary, sub:'asignados a ti',    nav:'clients',     Ic:Users,         bg:'#EEF2FF' },
    { l:'Ventas cerradas',   v:ganados,                         c:'#10b981', sub:'este mes',          nav:'clients',     Ic:CheckCircle,   bg:'#F0FDF4' },
    { l:'En negociación',    v:stats.clients?.en_proceso||0,   c:'#f59e0b', sub:'en proceso',         nav:'clients',     Ic:TrendingUp,    bg:'#FFFBEB' },
    { l:'Tasa conversión',   v:`${stats.tasa_conversion||0}%`, c:'#8b5cf6', sub:'de cierre',          nav:'clients',     Ic:Activity,      bg:'#F5F3FF' },
    { l:'Leads del bot',     v:stats.leads?.total||0,           c:'#ef4444', sub:'recibidos',          nav:'leads',       Ic:Bot,           bg:'#FFF1F2' },
    { l:'Leads calientes',   v:stats.leads?.calientes||0,      c:'#ef4444', sub:'alta prioridad',     nav:'leads',       Ic:Zap,           bg:'#FFF1F2' },
    { l:'Actividades mes',   v:stats.actions?.este_mes||0,     c:'#0ea5e9', sub:'realizadas',          nav:'actions',     Ic:Activity,      bg:'#EFF6FF' },
    { l:'Citas pendientes',  v:stats.events?.total||0,          c:'#f59e0b', sub:'próximas',           nav:'calendar',    Ic:Calendar,      bg:'#FFFBEB' },
  ];

  const nivelData = [
    { l:'Calientes', v:stats.leads?.calientes||0, c:'#ef4444', bg:'#fff5f5', nav:'leads' },
    { l:'Tibios',    v:stats.leads?.tibios||0,    c:'#f59e0b', bg:'#fffbeb', nav:'leads' },
    { l:'Fríos',     v:stats.leads?.frios||0,     c:DS.primary, bg:'#f0f1ff', nav:'leads' },
  ];

  return (
    <div style={{fontFamily:"'DM Sans',sans-serif"}}>

      {/* Header */}
      <div style={{marginBottom:24}}>
        <h1 style={{margin:0,fontSize:MOB?22:28,fontWeight:800,color:NAVY,letterSpacing:'-0.5px'}}>Mi Rendimiento</h1>
        <p style={{margin:'4px 0 0',fontSize:14,color:'#64748b'}}>Haz clic en cada card para ver el detalle</p>
      </div>

      {/* KPI Cards interactivas */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(4,1fr)',gap:MOB?10:14,marginBottom:24}}>
        {kpis.map((k,i)=>(
          <div key={i}
            onClick={()=>nav(k.nav)}
            onMouseEnter={()=>setHov(i)}
            onMouseLeave={()=>setHov(null)}
            style={{
              background:'var(--card-bg,#fff)', borderRadius:16, padding:MOB?'14px':'20px',
              border:'1px solid #e5e7eb',
              cursor:'pointer',
              transition:'all .2s',
              transform: hov===i ? 'translateY(-4px)' : 'none',
              boxShadow: hov===i ? `0 12px 28px ${k.c}25` : '0 1px 4px rgba(0,0,0,0.05)',
              position:'relative', overflow:'hidden',
            }}>
            {/* BG icon */}
            <div style={{position:'absolute',bottom:-8,right:-8,opacity:0.06}}>
              <k.Ic size={64} color={k.c}/>
            </div>
            {/* Icon */}
            <div style={{width:MOB?32:40,height:MOB?32:40,borderRadius:10,background:k.bg,display:'flex',alignItems:'center',justifyContent:'center',marginBottom:MOB?10:14,border:'1px solid #e5e7eb'}}>
              <k.Ic size={MOB?15:18} color={k.c}/>
            </div>
            <div style={{fontSize:MOB?22:28,fontWeight:800,color:'var(--dark,#0f172a)',lineHeight:1,marginBottom:4}}>{k.v}</div>
            <div style={{fontSize:MOB?11:12,fontWeight:700,color:'#475569'}}>{k.l}</div>
            <div style={{fontSize:10,color:k.c,marginTop:3,fontWeight:600}}>{k.sub} →</div>
          </div>
        ))}
      </div>

      {/* Row 2: Meta + Distribucion */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'1fr':'1fr 1fr',gap:16,marginBottom:16}}>

        {/* Meta del mes — CON VENTAS REALES */}
        <div style={{background:'#fff',borderRadius:16,padding:'22px',border:'1px solid #eaecf0',cursor:'pointer'}}
          onClick={()=>nav('clients')}
          onMouseEnter={e=>{e.currentTarget.style.boxShadow=`0 8px 24px ${p}15`;e.currentTarget.style.transform='translateY(-2px)';}}
          onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';e.currentTarget.style.transform='none';}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:16}}>
            <div>
              <div style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:2}}>Meta del mes</div>
              <div style={{fontSize:12,color:'#94a3b8'}}>Ventas cerradas este mes</div>
            </div>
            <div style={{textAlign:'right'}}>
              <div style={{fontSize:28,fontWeight:800,color:ganados>=meta?'#10b981':p,lineHeight:1}}>{ganados}</div>
              <div style={{fontSize:11,color:'#94a3b8'}}>de {meta} meta</div>
            </div>
          </div>
          <div style={{background:'#f1f5f9',borderRadius:999,height:12,overflow:'hidden',marginBottom:8}}>
            <div style={{
              width:`${avance}%`,height:'100%',
              background: avance>=100 ? 'linear-gradient(90deg,#10b981,#34d399)'
                        : avance>=60  ? `linear-gradient(90deg,${p},${p}cc)`
                        : 'linear-gradient(90deg,#f59e0b,#fbbf24)',
              borderRadius:999, transition:'width .8s',
            }}/>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <span style={{fontSize:11,color:'#94a3b8'}}>
              {avance>=100?'Meta cumplida':avance>=60?'Buen ritmo':'Sigue adelante'}
            </span>
            <span style={{fontSize:13,fontWeight:800,color:avance>=100?'#10b981':p}}>{avance}%</span>
          </div>
        </div>

        {/* Distribución de leads — interactiva */}
        <div style={{background:'#fff',borderRadius:16,padding:'22px',border:'1px solid #eaecf0'}}>
          <div style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)',marginBottom:16}}>Distribución de leads</div>
          {nivelData.map((n,i)=>{
            const pct=Math.round((n.v/totalLeads)*100);
            return(
              <div key={i} style={{marginBottom:12,cursor:'pointer'}}
                onClick={()=>nav(n.nav)}
                onMouseEnter={e=>{e.currentTarget.style.opacity='0.8';}}
                onMouseLeave={e=>{e.currentTarget.style.opacity='1';}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:5}}>
                  <div style={{display:'flex',alignItems:'center',gap:8}}>
                    <div style={{width:10,height:10,borderRadius:'50%',background:n.c}}/>
                    <span style={{fontSize:12,fontWeight:600,color:'#475569'}}>{n.l}</span>
                  </div>
                  <span style={{fontSize:12,fontWeight:800,color:n.c}}>{n.v} ({pct}%)</span>
                </div>
                <div style={{background:'#f1f5f9',borderRadius:999,height:7,overflow:'hidden'}}>
                  <div style={{width:`${pct}%`,height:'100%',background:n.c,borderRadius:999,transition:'width .5s'}}/>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Proximas citas — interactivas */}
      <div style={{background:'#fff',borderRadius:16,padding:'20px',border:'1px solid #eaecf0',marginBottom:16,cursor:'pointer'}}
        onClick={()=>nav('calendar')}
        onMouseEnter={e=>{e.currentTarget.style.boxShadow=`0 8px 24px ${p}10`;}}
        onMouseLeave={e=>{e.currentTarget.style.boxShadow='none';}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={{display:'flex',alignItems:'center',gap:8}}>
            <Calendar size={16} color={p}/>
            <span style={{fontSize:13,fontWeight:800,color:'var(--dark,#0f172a)'}}>Próximas citas</span>
          </div>
          <span style={{fontSize:11,color:p,fontWeight:700}}>Ver calendario →</span>
        </div>
        {events.filter(e=>new Date(e.date||e.event_date)>=new Date()).slice(0,4).length===0?(
          <div style={{textAlign:'center',color:'#94a3b8',fontSize:12,padding:'12px 0'}}>Sin citas agendadas — clic para agendar</div>
        ):(
          events.filter(e=>new Date(e.date||e.event_date)>=new Date()).sort((a,b)=>new Date(a.date||a.event_date)-new Date(b.date||b.event_date)).slice(0,4).map((ev,i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'9px 0',borderBottom:i<3?'1px solid #f8fafc':'none'}}>
              <div style={{width:42,height:42,borderRadius:10,background:`${p}10`,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',minWidth:42}}>
                <div style={{fontSize:14,fontWeight:800,color:p,lineHeight:1}}>{new Date(ev.date||ev.event_date).getDate()}</div>
                <div style={{fontSize:9,color:p,fontWeight:600}}>{['ENE','FEB','MAR','ABR','MAY','JUN','JUL','AGO','SEP','OCT','NOV','DIC'][new Date(ev.date||ev.event_date).getMonth()]}</div>
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)'}}>{ev.cname||ev.client_name||'Cliente'}</div>
                <div style={{fontSize:11,color:'#94a3b8'}}>{ev.time||ev.event_time||'Sin hora'} — {ev.notes||ev.type||'Cita'}</div>
              </div>
              <div style={{fontSize:10,background:`${p}10`,color:p,padding:'3px 9px',borderRadius:6,fontWeight:700}}>
                {ev.type==='cita'?'Cita':ev.type==='llamada'?'Llamada':'Actividad'}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Resumen rendimiento — interactivo */}
      <div style={{display:'grid',gridTemplateColumns:MOB?'repeat(2,1fr)':'repeat(3,1fr)',gap:12}}>
        {[
          {l:'Score promedio',   v:`${stats.leads?.score_promedio||0}/100`, c:DS.primary, sub:'de tus leads',  nav:'leads',    Ic:Activity},
          {l:'Actividades hoy', v:stats.actions?.hoy||0,                   c:'#10b981', sub:'registradas',    nav:'actions',  Ic:CheckCircle},
          {l:'Leads nuevos hoy',v:stats.leads?.hoy||0,                     c:'#f59e0b', sub:'del bot',        nav:'leads',    Ic:Zap},
        ].map((s,i)=>(
          <div key={i}
            onClick={()=>nav(s.nav)}
            style={{background:'var(--card-bg,#fff)',borderRadius:14,padding:'18px',border:'1px solid #e5e7eb',cursor:'pointer',textAlign:'center',transition:'all .2s'}}
            onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-3px)';e.currentTarget.style.boxShadow=`0 8px 20px ${s.c}20`;}}
            onMouseLeave={e=>{e.currentTarget.style.transform='none';e.currentTarget.style.boxShadow='none';}}>
            <s.Ic size={20} color={s.c} style={{marginBottom:8}}/>
            <div style={{fontSize:24,fontWeight:800,color:s.c}}>{s.v}</div>
            <div style={{fontSize:12,fontWeight:700,color:'var(--dark,#0f172a)',marginTop:4}}>{s.l}</div>
            <div style={{fontSize:11,color:'#94a3b8',marginTop:2}}>{s.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}




export default function DashboardAsesor({user,currentView,onNavigate,primary=DS.primary,pageBg='#f0f4ff',cardBg='#ffffff',cardBorder,cardShadow}) {
  DS = makeDS(primary);
  CB = cardBg || '#ffffff'; // update module-level for sub-components
  CBorder = cardBorder || `${primary}20`;
  MOB = window.innerWidth < 768; // actualiza flag móvil en cada render
  syncAdminTheme(primary); // Inicio/Pipeline vienen del panel admin
  CShadow = cardShadow || `0 2px 12px ${primary}14`;
  const [clients,  setClients]  = useState([]);
  const [events,   setEvents]   = useState([]);
  const [actions,  setActions]  = useState([]);
  const [leads,    setLeads]    = useState([]);
  const [contacts, setContacts] = useState([]);
  const [stats,    setStats]    = useState(null);
  const [call,     setCall]     = useState(null);
  const [confirmDlg, setConfirmDlg] = useState(null);
  _setConfirm = setConfirmDlg;
  const [waDlg, setWaDlg] = useState(null);
  _setWA = setWaDlg;
  const [convInitial, setConvInitial] = useState(null);
  const [clientInitial, setClientInitial] = useState(null);
  const nav  = onNavigate||(()=>{});
  const view = currentView||'dashboard';

  // Al hacer clic en una notificación → abrir la ficha del cliente
  useEffect(() => {
    const h = (e) => {
      const d = e.detail || {};
      const digits = String(d.phone||'').replace(/\D/g,'');
      const cli = clients.find(c => {
        const cd = String(c.phone||'').replace(/\D/g,'');
        return (digits && cd && cd.slice(-9) === digits.slice(-9)) || (d.name && c.name === d.name);
      });
      if (cli) { setClientInitial(cli.id); nav('clients'); }
      else alert('Este cliente no está en tu cartera.');
    };
    window.addEventListener('crm:open-client', h);
    return () => window.removeEventListener('crm:open-client', h);
  }, [clients, nav]);

  // Ver conversación del bot con un cliente: busca su lead por teléfono y navega
  function verConversacionCliente(client) {
    const digits = String(client?.phone||'').replace(/\D/g,'');
    const lead = leads.find(l => {
      const ld = String(l.telefono||l.phone||'').replace(/\D/g,'');
      return ld && digits && ld.slice(-9) === digits.slice(-9);
    });
    // Si el lead fue borrado y solo quedó el cliente, se queda como cliente: sin conversación
    if (!lead) { alert('Este cliente no tiene lead con conversación del bot.'); return; }
    setConvInitial(lead);
    nav('conversaciones');
  }

  const cargar = useCallback(async () => {
    // Cada respuesta se pinta en cuanto llega (antes Promise.all esperaba a la más lenta)
    const err = e => console.error('Error cargando datos asesor:', e.message);
    await Promise.all([
      apiFetch('GET','/api/asesor/clients').then(clientsRes => {
      if (Array.isArray(clientsRes)) {   // sin filtro: refleja TODOS los clientes del asesor
        setClients(clientsRes.map(c=>({
          ...c,
          result:   c.metadata?.result||null,
          heat:     c.metadata?.heat||c.heat||'tibio',
          last:     c.last_contact||c.created_at,
          name:     c.name||'Sin nombre',
          producto: c.metadata?.producto||c.producto||'',
          cedula:   c.metadata?.cedula||c.cedula||'',
        })));
      }
      }).catch(err),
      apiFetch('GET','/api/asesor/stats').then(statsRes => {
      if (statsRes) setStats(statsRes);
      }).catch(err),
      apiFetch('GET','/api/asesor/activities').then(activRes => {
      if (Array.isArray(activRes) && activRes.length>0) {
        setActions(activRes.map(a=>({
          ...a, cid:a.client_id, cname:a.client_name||'—',
          at:a.created_at, dur:a.duration||0,
        })));
      }
      }).catch(err),
      apiFetch('GET','/api/asesor/calendar').then(calRes => {
      if (Array.isArray(calRes) && calRes.length>0) {
        setEvents(calRes.map(e=>({
          ...e, date:e.event_date, time:e.event_time||'',
          client:e.client_name||'—', done:e.done||false,
        })));
      }
      }).catch(err),
      apiFetch('GET','/api/asesor/leads').then(leadsRes => {
      if (Array.isArray(leadsRes)) {   // sin filtro: refleja TODOS los leads del asesor
        setLeads(leadsRes.map(l=>({
          ...l, nivel:l.nivel||'tibio', score:l.score||50,
          msgBot:l.msg_bot||'', telefono:l.telefono||l.phone||'',
          cedula:l.metadata?.cedula||l.cedula||'',
        })));
      }
      }).catch(err),
      apiFetch('GET','/api/asesor/contacts').then(contactsRes => {
      if (Array.isArray(contactsRes)) setContacts(contactsRes);
      }).catch(err),
    ]);
  }, []);

  // Recarga al volver a la pestaña y cada 2 min: si el supervisor reasigna un cliente,
  // desaparece del panel del asesor anterior sin que tenga que recargar la página.
  useEffect(() => {
    cargar();
    const t = setInterval(cargar, 120000);
    window.addEventListener('focus', cargar);
    return () => { clearInterval(t); window.removeEventListener('focus', cargar); };
  }, [cargar]);
  _onContacto = cargar;   // tras marcar contacto por WhatsApp, refrescar para que salga de "Sin contacto"

  async function handleCallSave(d){
    try {
      await apiFetch('POST','/api/asesor/activities',{
        clientId:call.id, type:d.type, resultado:d.resultado||'',
        notas:d.notas||'', duration:d.dur||0,
      });
      setActions(p=>[{id:'a'+Date.now(),type:d.type,cid:call.id,cname:call.name,at:new Date().toISOString(),dur:d.dur,resultado:d.resultado||'',notas:d.notas||''},...p]);
    } catch(e) { console.error(e.message); }
    setClients(p=>p.map(c=>c.id===call.id?{...c,last:new Date().toISOString()}:c));
    setCall(null);
  }

  return(
    <>
      {call&&<CallModal client={call} onSave={handleCallSave} onClose={()=>setCall(null)}/>}
      {confirmDlg&&<ConfirmModal msg={confirmDlg.msg} onYes={confirmDlg.onYes} onClose={()=>setConfirmDlg(null)}/>}
      {waDlg&&<WhatsAppModal data={waDlg} onClose={()=>setWaDlg(null)}/>}
      {view==='dashboard' &&<InicioAdmin mine user={user} users={[]} leads={leads} clients={clients} activities={actions} onNavigate={nav}/>}
      {view==='clients' /* export: clients */   &&<><PageHead title="Mis clientes" sub="Tus clientes · toca uno para ver el detalle, llamar o marcar la venta"/><TabClientes    clients={clients} setClients={setClients} onCall={setCall} onRefresh={cargar} onVerConversacion={verConversacionCliente} initialId={clientInitial} onInitialDone={()=>setClientInitial(null)}/></>}
      {view==='calendar'  &&<><PageHead title="Calendario" sub="Tus citas y seguimientos"/><TabCalendario  events={events} setEvents={setEvents} clients={clients} onRefresh={cargar}/></>}
      {view==='actions'   &&<><PageHead title="Actividades" sub="Llamadas, mensajes y tareas con tus clientes"/><TabActividades actions={actions} setActions={setActions} clients={clients} onCall={setCall}/></>}
      {view==='messages'  &&<><PageHead title="Mensajes" sub="Chat interno con tu supervisor"/><TabMensajes    contacts={contacts}/></>}
      {view==='estadisticas'     &&<TabEstadisticasPersonales stats={stats} leads={leads} clients={clients} actions={actions} events={events} onNavigate={nav}/>}
      {view==='conversaciones'   &&<><PageHead title="Conversaciones" sub="Chats del bot de WhatsApp con tus leads"/><TabBotConversaciones leads={leads} initial={convInitial}/></>}
      {(view==='pipeline'||view==='leads') &&<><PageHead title="Pipeline" sub={`${leads.length.toLocaleString('es-EC')} leads tuyos · arrastra una tarjeta para cambiarla de etapa`}/><PipelineTablero mine meId={user?.id} leads={leads} setLeads={setLeads} clients={clients} users={[]}/></>}
    </>
  );
}
